import * as moment from 'moment';
import { ApiService } from '../../services/api.service';  
import { Injectable } from '@angular/core';
import * as x from '../contracts/Turbo.Data.Contracts';
@Injectable({providedIn: 'root' })
export class T4DataService {
  constructor(private api: ApiService) {}
  public async GetImageUri(type: any, entityId: string, locationId: number, ) : Promise<string> {
      return await this.api.get<string>("Data/GetImageUri", { type: type, entityId: entityId, locationId: locationId });
  }
  public async GetCurrentGroupImageUri() : Promise<string> {
      return await this.api.get<string>("Data/GetCurrentGroupImageUri", {  });
  }
  public async GetImage(type: any, entityId: string, locationId: number, fallback: boolean, ) : Promise<x.T4Image> {
      return await this.api.get<x.T4Image>("Data/GetImage", { type: type, entityId: entityId, locationId: locationId, fallback: fallback });
  }
  public async SetImage(type: any, entityId: string, data: string) : Promise<any> {
      return await this.api.post<any>("Data/SetImage", data, { type: type, entityId: entityId });
  }
  public async SetDefaultOfferImageImage(entityId: string, ) : Promise<any> {
      return await this.api.post<any>("Data/SetDefaultOfferImageImage", null, { entityId: entityId });
  }
  public async StorePickupPhoto(rentalId: number, angleId: number, data: string) : Promise<string> {
      return await this.api.post<string>("Data/StorePickupPhoto", data, { rentalId: rentalId, angleId: angleId });
  }
  public async StoreReturnPhoto(rentalId: number, angleId: number, data: string) : Promise<string> {
      return await this.api.post<string>("Data/StoreReturnPhoto", data, { rentalId: rentalId, angleId: angleId });
  }
  public async GetReport(reportName: string, from: moment.Moment, to: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("Data/GetReport", { reportName: reportName, from: from.toISOString(), to: to.toISOString() });
  }
  public async GetReport1(reportId: string, ) : Promise<x.ReportInfo> {
      return await this.api.get<x.ReportInfo>("Data/GetReport", { reportId: reportId });
  }
  public async GetReportRuns(reportId: string, ) : Promise<x.ReportRunInfo[]> {
      return await this.api.get<x.ReportRunInfo[]>("Data/GetReportRuns", { reportId: reportId });
  }
  public async RunReport(reportId: string, from: moment.Moment, to: moment.Moment, format: any, ) : Promise<x.ReportRunInfo> {
      return await this.api.get<x.ReportRunInfo>("Data/RunReport", { reportId: reportId, from: from.toISOString(), to: to.toISOString(), format: format });
  }
  public async GetReportSchedule(reportName: string, ) : Promise<string> {
      return await this.api.get<string>("Data/GetReportSchedule", { reportName: reportName });
  }
  public async ScheduleReport(reportName: string, email: string, webhook: string, from: moment.Moment, to: moment.Moment, format: any, interval: any, weekDay: any, ) : Promise<string> {
      return await this.api.post<string>("Data/ScheduleReport", null, { reportName: reportName, email: email, webhook: webhook, from: from.toISOString(), to: to.toISOString(), format: format, interval: interval, weekDay: weekDay });
  }
  public async DropReportSchedule(scheduleId: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Data/DropReportSchedule", { scheduleId: scheduleId });
  }
  public async GetEntityEvents(entityId: string, entityType: any, ) : Promise<any> {
      return await this.api.get<any>("Data/GetEntityEvents", { entityId: entityId, entityType: entityType });
  }
  public async GetEntityAttachments(id: string, ) : Promise<any> {
      return await this.api.get<any>("Data/GetEntityAttachments", { id: id });
  }
  public async AddEntityEvent(entityId: string, entityType: any, message: string, eventType: number, ) : Promise<string> {
      return await this.api.get<string>("Data/AddEntityEvent", { entityId: entityId, entityType: entityType, message: message, eventType: eventType });
  }
  public async AddEntityEventFromDevice(entityId: string, entityType: any, message: string, metadata: string, eventType: number, ) : Promise<string> {
      return await this.api.get<string>("Data/AddEntityEventFromDevice", { entityId: entityId, entityType: entityType, message: message, metadata: metadata, eventType: eventType });
  }
}
@Injectable({providedIn: 'root' })
export class T4OneWayService {
  constructor(private api: ApiService) {}
  public async LoadLocations() : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("OneWay/LoadLocations", {  });
  }
  public async LoadInspectionMap(dayLimit: number, ) : Promise<x.MapPoint[]> {
      return await this.api.get<x.MapPoint[]>("OneWay/LoadInspectionMap", { dayLimit: dayLimit });
  }
  public async LoadTransportOrders() : Promise<x.MapPoint[]> {
      return await this.api.get<x.MapPoint[]>("OneWay/LoadTransportOrders", {  });
  }
  public async GetOverview(weekId: number, bookingTypes: any, objectTypes: any, logistics: boolean, ) : Promise<x.LocationOverview[]> {
      return await this.api.get<x.LocationOverview[]>("OneWay/GetOverview", { weekId: weekId, bookingTypes: bookingTypes, objectTypes: objectTypes, logistics: logistics });
  }
  public async GetBookingQueue(locationId: number, objectTypes: any, weekId: number, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("OneWay/GetBookingQueue", { locationId: locationId, objectTypes: objectTypes, weekId: weekId });
  }
  public async GetDisclosedBookings(locationId: any, ) : Promise<any> {
      return await this.api.get<any>("OneWay/GetDisclosedBookings", { locationId: locationId });
  }
  public async GetLateRentals(minHours: number, ) : Promise<any> {
      return await this.api.get<any>("OneWay/GetLateRentals", { minHours: minHours });
  }
  public async GetLeads(weekId: number, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("OneWay/GetLeads", { weekId: weekId });
  }
  public async GetTrailerPositions(locationId: number, objectTypes: any, weekId: number, ) : Promise<x.RentalObjectPosition[]> {
      return await this.api.get<x.RentalObjectPosition[]>("OneWay/GetTrailerPositions", { locationId: locationId, objectTypes: objectTypes, weekId: weekId });
  }
  public async GetDisabledTrailers(locationId: number, ) : Promise<x.RentalObjectPosition[]> {
      return await this.api.get<x.RentalObjectPosition[]>("OneWay/GetDisabledTrailers", { locationId: locationId });
  }
  public async GetTrailerWhereabouts() : Promise<x.LockPosition[]> {
      return await this.api.get<x.LockPosition[]>("OneWay/GetTrailerWhereabouts", {  });
  }
  public async GetEstimatedDate(rentalId: any, ) : Promise<x.RentalInfo> {
      return await this.api.get<x.RentalInfo>("OneWay/GetEstimatedDate", { rentalId: rentalId });
  }
  public async IsRentalObjectOnStation(rentalId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("OneWay/IsRentalObjectOnStation", { rentalId: rentalId });
  }
  public async GetSales(from: moment.Moment, to: moment.Moment, ) : Promise<x.DateValue[]> {
      return await this.api.get<x.DateValue[]>("OneWay/GetSales", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetInvoices(from: moment.Moment, to: moment.Moment, ) : Promise<x.InvoiceSpecification[]> {
      return await this.api.get<x.InvoiceSpecification[]>("OneWay/GetInvoices", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetCurrentBudget(from: moment.Moment, to: moment.Moment, ) : Promise<x.DateValue[]> {
      return await this.api.get<x.DateValue[]>("OneWay/GetCurrentBudget", { from: from.toISOString(), to: to.toISOString() });
  }
  public async StartCounting() : Promise<any> {
      return await this.api.get<any>("OneWay/StartCounting", {  });
  }
  public async CheckForActiveCounting() : Promise<boolean> {
      return await this.api.get<boolean>("OneWay/CheckForActiveCounting", {  });
  }
  public async ValidateCountingResults(objectIds: string, ) : Promise<x.OneWayCountingResultInfo[]> {
      return await this.api.get<x.OneWayCountingResultInfo[]>("OneWay/ValidateCountingResults", { objectIds: objectIds });
  }
  public async GetActiveCounting() : Promise<string> {
      return await this.api.get<string>("OneWay/GetActiveCounting", {  });
  }
  public async SaveCountingResult(id: string, objectIds: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("OneWay/SaveCountingResult", null, { id: id, objectIds: objectIds });
  }
  public async GetCountings() : Promise<x.OneWayCountingInfo[]> {
      return await this.api.get<x.OneWayCountingInfo[]>("OneWay/GetCountings", {  });
  }
  public async GetCountingOverview(id: string, ) : Promise<x.OneWayCountingInfo> {
      return await this.api.get<x.OneWayCountingInfo>("OneWay/GetCountingOverview", { id: id });
  }
  public async GetCountingDiscrepancies(id: string, ) : Promise<x.OneWayCountingResultInfo[]> {
      return await this.api.get<x.OneWayCountingResultInfo[]>("OneWay/GetCountingDiscrepancies", { id: id });
  }
  public async GetCountingStatus(id: string, ) : Promise<x.OneWayCountingLocationInfo[]> {
      return await this.api.get<x.OneWayCountingLocationInfo[]>("OneWay/GetCountingStatus", { id: id });
  }
  public async ApproveCountingResult(id: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("OneWay/ApproveCountingResult", null, { id: id });
  }
  public async RejectCountingResult(id: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("OneWay/RejectCountingResult", null, { id: id });
  }
  public async ValidateNumber(number: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("OneWay/ValidateNumber", { number: number });
  }
}
@Injectable({providedIn: 'root' })
export class T4ServiceService {
  constructor(private api: ApiService) {}
  public async GetActiveRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetActiveRequests", { oneway: oneway });
  }
  public async GetActiveRequestsForObject(id: any, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetActiveRequestsForObject", { id: id });
  }
  public async GetServicePartners(lat: number, lng: number, ) : Promise<x.ServiceLocationInfo[]> {
      return await this.api.get<x.ServiceLocationInfo[]>("Service/GetServicePartners", { lat: lat, lng: lng });
  }
  public async GetNewInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetNewInsuranceRequests", { oneway: oneway });
  }
  public async GetUrgentInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetUrgentInsuranceRequests", { oneway: oneway });
  }
  public async GetHandledInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetHandledInsuranceRequests", { oneway: oneway });
  }
  public async GetActiveInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetActiveInsuranceRequests", { oneway: oneway });
  }
  public async GetCompletedInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetCompletedInsuranceRequests", { oneway: oneway });
  }
  public async GetIncompleteInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetIncompleteInsuranceRequests", { oneway: oneway });
  }
  public async GetInsuranceRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetInsuranceRequests", { oneway: oneway });
  }
  public async GetClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetClaimRequests", { oneway: oneway });
  }
  public async GetNewClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetNewClaimRequests", { oneway: oneway });
  }
  public async GetUrgentClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetUrgentClaimRequests", { oneway: oneway });
  }
  public async GetHandledClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetHandledClaimRequests", { oneway: oneway });
  }
  public async GetActiveClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetActiveClaimRequests", { oneway: oneway });
  }
  public async GetCompletedClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetCompletedClaimRequests", { oneway: oneway });
  }
  public async GetClaimStatistics(from: moment.Moment, to: moment.Moment, oneway: boolean, ) : Promise<any> {
      return await this.api.get<any>("Service/GetClaimStatistics", { from: from.toISOString(), to: to.toISOString(), oneway: oneway });
  }
  public async GetIncompleteClaimRequests(oneway: boolean, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/GetIncompleteClaimRequests", { oneway: oneway });
  }
  public async ConvertToClaim(requestId: string, claimId: string, ) : Promise<x.RequestDetails> {
      return await this.api.post<x.RequestDetails>("Service/ConvertToClaim", null, { requestId: requestId, claimId: claimId });
  }
  public async RevertClaim(requestId: string, ) : Promise<x.RequestDetails> {
      return await this.api.post<x.RequestDetails>("Service/RevertClaim", null, { requestId: requestId });
  }
  public async FindRequests(keywords: string, limit: number, ) : Promise<x.RequestDetails[]> {
      return await this.api.get<x.RequestDetails[]>("Service/FindRequests", { keywords: keywords, limit: limit });
  }
  public async GetRequest(id: string, ) : Promise<x.RequestDetails> {
      return await this.api.get<x.RequestDetails>("Service/GetRequest", { id: id });
  }
  public async RequestService(objectId: number, description: string, disableTrailer: boolean, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/RequestService", null, { objectId: objectId, description: description, disableTrailer: disableTrailer });
  }
  public async CreateRequest(rentalObjectId: number, description: string, isInsurance: boolean, disable: boolean, tags: any, imageIdentifier: string, images: string, incidentDate: moment.Moment, ContactFirstName: string, ContactLastName: string, ContactEmail: string, ContactPhone: string, RecordNumber: string, preDefinedID: string, servicePartnerId: number, ) : Promise<x.RequestDetails> {
      return await this.api.post<x.RequestDetails>("Service/CreateRequest", null, { rentalObjectId: rentalObjectId, description: description, isInsurance: isInsurance, disable: disable, tags: tags, imageIdentifier: imageIdentifier, images: images, incidentDate: incidentDate.toISOString(), ContactFirstName: ContactFirstName, ContactLastName: ContactLastName, ContactEmail: ContactEmail, ContactPhone: ContactPhone, RecordNumber: RecordNumber, preDefinedID: preDefinedID, servicePartnerId: servicePartnerId });
  }
  public async SetLFInvoiceForRequest(requestId: string, invoice: boolean, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/SetLFInvoiceForRequest", null, { requestId: requestId, invoice: invoice });
  }
  public async CreateUserRequest(rentalObjectId: number, description: string, isInsurance: boolean, tags: any, ) : Promise<x.RequestDetails> {
      return await this.api.post<x.RequestDetails>("Service/CreateUserRequest", null, { rentalObjectId: rentalObjectId, description: description, isInsurance: isInsurance, tags: tags });
  }
  public async UpdateRequestContactDetails(requestId: string, ContactFirstName: string, ContactLastName: string, ContactEmail: string, ContactPhone: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateRequestContactDetails", null, { requestId: requestId, ContactFirstName: ContactFirstName, ContactLastName: ContactLastName, ContactEmail: ContactEmail, ContactPhone: ContactPhone });
  }
  public async UpdateRequest(update: x.RequestUpdate, ) : Promise<x.RequestDetails> {
      return await this.api.post<x.RequestDetails>("Service/UpdateRequest", null, { update: update });
  }
  public async RepurchaseRequest(requestId: string, ) : Promise<x.RequestDetails> {
      return await this.api.post<x.RequestDetails>("Service/RepurchaseRequest", null, { requestId: requestId });
  }
  public async EscelateRequest(requestNr: number, comment: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/EscelateRequest", null, { requestNr: requestNr, comment: comment });
  }
  public async CreateInvoice(requestId: string, amount: number, text: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Service/CreateInvoice", { requestId: requestId, amount: amount, text: text });
  }
  public async GetServiceLocations(rentalObjectId: number, ) : Promise<x.ServiceLocationInfo[]> {
      return await this.api.get<x.ServiceLocationInfo[]>("Service/GetServiceLocations", { rentalObjectId: rentalObjectId });
  }
  public async SendRequestFeedback(requestId: string, body: string, feedbackType: any, ) : Promise<any> {
      return await this.api.get<any>("Service/SendRequestFeedback", { requestId: requestId, body: body, feedbackType: feedbackType });
  }
  public async SendEmailThroughService(to: string, subject: string, body: string) : Promise<boolean> {
      return await this.api.post<boolean>("Service/SendEmailThroughService", body, { to: to, subject: subject });
  }
  public async UploadFile(requestId: string, filename: string, data: any, mimetype: string, ) : Promise<any> {
      return await this.api.post<any>("Service/UploadFile", null, { requestId: requestId, filename: filename, data: data, mimetype: mimetype });
  }
  public async UploadFileFromT4(requestId: string, filename: string, mimetype: string, data: string) : Promise<any> {
      return await this.api.post<any>("Service/UploadFileFromT4", data, { requestId: requestId, filename: filename, mimetype: mimetype });
  }
  public async RemoveFile(requestId: string, filename: string, ) : Promise<any> {
      return await this.api.post<any>("Service/RemoveFile", null, { requestId: requestId, filename: filename });
  }
  public async GetFiles(requestId: string, ) : Promise<x.T4File[]> {
      return await this.api.get<x.T4File[]>("Service/GetFiles", { requestId: requestId });
  }
  public async UpdateServiceRequest() : Promise<any> {
      return await this.api.post<any>("Service/UpdateServiceRequest", null, {  });
  }
  public async GetServiceGuys() : Promise<x.ServiceGuyInfo[]> {
      return await this.api.get<x.ServiceGuyInfo[]>("Service/GetServiceGuys", {  });
  }
  public async GetLocationServiceGuy(locationId: number, ) : Promise<x.ServiceGuyInfo> {
      return await this.api.get<x.ServiceGuyInfo>("Service/GetLocationServiceGuy", { locationId: locationId });
  }
  public async GetLocationByServiceGuyId(ServiceGuyId: string, ) : Promise<x.LocationInfo> {
      return await this.api.get<x.LocationInfo>("Service/GetLocationByServiceGuyId", { ServiceGuyId: ServiceGuyId });
  }
  public async GetServiceGuy(ServiceGuyId: string, ) : Promise<x.ServiceGuyInfo> {
      return await this.api.get<x.ServiceGuyInfo>("Service/GetServiceGuy", { ServiceGuyId: ServiceGuyId });
  }
  public async GetGeneralLockInfo(Id: string, ) : Promise<x.SmartLockInfo> {
      return await this.api.get<x.SmartLockInfo>("Service/GetGeneralLockInfo", { Id: Id });
  }
  public async GetLowBatteryList(highThreshold: number, lowThreshold: number, days: number, ) : Promise<any> {
      return await this.api.get<any>("Service/GetLowBatteryList", { highThreshold: highThreshold, lowThreshold: lowThreshold, days: days });
  }
  public async GetInventoryStatus() : Promise<x.InventoryStatus[]> {
      return await this.api.get<x.InventoryStatus[]>("Service/GetInventoryStatus", {  });
  }
  public async GetDamages(LocationId: number, ) : Promise<x.DamageInfo[]> {
      return await this.api.get<x.DamageInfo[]>("Service/GetDamages", { LocationId: LocationId });
  }
  public async RegisterCheckup(checkup: x.LocationCheckupInfo, ) : Promise<any> {
      return await this.api.post<any>("Service/RegisterCheckup", null, { checkup: checkup });
  }
  public async SendRemindersUnDoneCheckups(fromDate: moment.Moment, toDate: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("Service/SendRemindersUnDoneCheckups", { fromDate: fromDate.toISOString(), toDate: toDate.toISOString() });
  }
  public async GetLatestRegisteredCheckupDate(locationId: number, ) : Promise<moment.Moment> {
      return await this.api.get<moment.Moment>("Service/GetLatestRegisteredCheckupDate", { locationId: locationId });
  }
  public async RegisterHandleServiceGuy(rentalObjectId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/RegisterHandleServiceGuy", null, { rentalObjectId: rentalObjectId });
  }
  public async RegisterHandleCustomerSupport(rentalObjectId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/RegisterHandleCustomerSupport", null, { rentalObjectId: rentalObjectId });
  }
  public async RegisterHandledComplete(rentalObjectId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/RegisterHandledComplete", null, { rentalObjectId: rentalObjectId });
  }
  public async AssignServiceGuy(guyId: string, locationId: any, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/AssignServiceGuy", null, { guyId: guyId, locationId: locationId });
  }
  public async UpdateServiceGuy(serviceGuy: x.ServiceGuyInfo, ) : Promise<x.ServiceGuyInfo> {
      return await this.api.post<x.ServiceGuyInfo>("Service/UpdateServiceGuy", null, { serviceGuy: serviceGuy });
  }
  public async DeleteServiceGuy(id: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Service/DeleteServiceGuy", { id: id });
  }
  public async CreateServiceGuy(serviceGuy: x.ServiceGuyInfo, ) : Promise<x.ServiceGuyInfo> {
      return await this.api.post<x.ServiceGuyInfo>("Service/CreateServiceGuy", null, { serviceGuy: serviceGuy });
  }
  public async GetInStock(serviceGuyId: string, ) : Promise<x.InventoryItemInfo[]> {
      return await this.api.get<x.InventoryItemInfo[]>("Service/GetInStock", { serviceGuyId: serviceGuyId });
  }
  public async GetItems() : Promise<x.ItemInfo[]> {
      return await this.api.get<x.ItemInfo[]>("Service/GetItems", {  });
  }
  public async GetStockItems(serviceGuyId: string, ) : Promise<any> {
      return await this.api.get<any>("Service/GetStockItems", { serviceGuyId: serviceGuyId });
  }
  public async UpdateStock(serviceGuyId: string, list: x.ItemInfo[]) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateStock", list, { serviceGuyId: serviceGuyId });
  }
  public async CreateItem(item: x.ItemInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/CreateItem", null, { item: item });
  }
  public async DeleteItem(itemId: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Service/DeleteItem", { itemId: itemId });
  }
  public async UpdateItemArticle(item: x.ItemInfo, newName: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateItemArticle", null, { item: item, newName: newName });
  }
  public async CreateServiceGuyType(type: x.ServiceGuyTypeInfo) : Promise<boolean> {
      return await this.api.post<boolean>("Service/CreateServiceGuyType", type, {  });
  }
  public async GetSGInventoryAssets(serviceGuyId: string, ) : Promise<x.InventoryAssetInfo[]> {
      return await this.api.get<x.InventoryAssetInfo[]>("Service/GetSGInventoryAssets", { serviceGuyId: serviceGuyId });
  }
  public async GetServiceGuyTypes() : Promise<x.ServiceGuyTypeInfo[]> {
      return await this.api.get<x.ServiceGuyTypeInfo[]>("Service/GetServiceGuyTypes", {  });
  }
  public async DeleteServiceGuyType(typeId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/DeleteServiceGuyType", null, { typeId: typeId });
  }
  public async UpdateServiceGuyType(update: x.ServiceGuyTypeInfo) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateServiceGuyType", update, {  });
  }
  public async GetServiceGuyTypeStockSettings(typeId: number, ) : Promise<x.ServiceGuyTypeStockSettingInfo[]> {
      return await this.api.get<x.ServiceGuyTypeStockSettingInfo[]>("Service/GetServiceGuyTypeStockSettings", { typeId: typeId });
  }
  public async GetLoggedInServiceGuyTypeItems() : Promise<any> {
      return await this.api.get<any>("Service/GetLoggedInServiceGuyTypeItems", {  });
  }
  public async UpdateServiceGuyStockSetting(update: x.ServiceGuyTypeStockSettingInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateServiceGuyStockSetting", null, { update: update });
  }
  public async UpdateServiceGuyStockSettings(updates: x.ServiceGuyTypeStockSettingInfo[], ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateServiceGuyStockSettings", null, { updates: updates });
  }
  public async UpdateItem(item: x.ItemInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/UpdateItem", null, { item: item });
  }
  public async TransferAssets(AssetIds: string[], sgId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/TransferAssets", null, { AssetIds: AssetIds, sgId: sgId });
  }
  public async ScrapAssets(asset: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/ScrapAssets", null, { asset: asset });
  }
  public async TransferAsset(AssetId: string, sgId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/TransferAsset", null, { AssetId: AssetId, sgId: sgId });
  }
  public async DisconnectAsset(AssetId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/DisconnectAsset", null, { AssetId: AssetId });
  }
  public async GetActiveContract(AssetId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Service/GetActiveContract", { AssetId: AssetId });
  }
  public async ScrapAsset(AssetId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/ScrapAsset", null, { AssetId: AssetId });
  }
  public async GetAssets() : Promise<x.AssetInfo[]> {
      return await this.api.get<x.AssetInfo[]>("Service/GetAssets", {  });
  }
  public async GetAssetsWithContractStatus() : Promise<x.AssetInfo[]> {
      return await this.api.get<x.AssetInfo[]>("Service/GetAssetsWithContractStatus", {  });
  }
  public async GetActiveAssets(contextId: string, ) : Promise<x.AssetInfo[]> {
      return await this.api.get<x.AssetInfo[]>("Service/GetActiveAssets", { contextId: contextId });
  }
  public async GetAssetInfo(Id: string, ) : Promise<x.AssetInfo> {
      return await this.api.get<x.AssetInfo>("Service/GetAssetInfo", { Id: Id });
  }
  public async GetAssetTransactions(AssetId: string, ) : Promise<x.AssetTransactionInfo[]> {
      return await this.api.get<x.AssetTransactionInfo[]>("Service/GetAssetTransactions", { AssetId: AssetId });
  }
  public async GetAllInventoryAssets() : Promise<x.InventoryAssetInfo[]> {
      return await this.api.get<x.InventoryAssetInfo[]>("Service/GetAllInventoryAssets", {  });
  }
  public async GetAssetHistory(AssetId: string, ) : Promise<any> {
      return await this.api.get<any>("Service/GetAssetHistory", { AssetId: AssetId });
  }
  public async LockLogs(lockId: string, ) : Promise<x.LockLogInfo[]> {
      return await this.api.get<x.LockLogInfo[]>("Service/LockLogs", { lockId: lockId });
  }
  public async GetInventoryAssets(AssetId: string, ) : Promise<x.InventoryAssetInfo[]> {
      return await this.api.get<x.InventoryAssetInfo[]>("Service/GetInventoryAssets", { AssetId: AssetId });
  }
  public async KpiActiveIssues(from: moment.Moment, to: moment.Moment, ) : Promise<x.RentalKPI> {
      return await this.api.get<x.RentalKPI>("Service/KpiActiveIssues", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetLFResidualValue(damageDate: moment.Moment, onRentDate: moment.Moment, originalValue: number, ) : Promise<number> {
      return await this.api.get<number>("Service/GetLFResidualValue", { damageDate: damageDate.toISOString(), onRentDate: onRentDate.toISOString(), originalValue: originalValue });
  }
  public async GetUpcomingTrailers(searchText: string, limit: number, onlyConnected: boolean, ) : Promise<x.UpcomingRegistrationNumberInfo[]> {
      return await this.api.get<x.UpcomingRegistrationNumberInfo[]>("Service/GetUpcomingTrailers", { searchText: searchText, limit: limit, onlyConnected: onlyConnected });
  }
  public async FilterUpcomingTrailers(searchText: string, limit: number, ) : Promise<x.UpcomingRegistrationNumberInfo[]> {
      return await this.api.get<x.UpcomingRegistrationNumberInfo[]>("Service/FilterUpcomingTrailers", { searchText: searchText, limit: limit });
  }
  public async DeleteUpcomingTrailers(upcomingTrailerId: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Service/DeleteUpcomingTrailers", { upcomingTrailerId: upcomingTrailerId });
  }
  public async ValidateUpcomingTrailers(data: string) : Promise<any> {
      return await this.api.post<any>("Service/ValidateUpcomingTrailers", data, {  });
  }
  public async ImportTrackers(filename: string, mimetype: string, data: string) : Promise<boolean> {
      return await this.api.post<boolean>("Service/ImportTrackers", data, { filename: filename, mimetype: mimetype });
  }
  public async UploadFileUpcomingTrailers(filename: string, mimetype: string, data: string) : Promise<any> {
      return await this.api.post<any>("Service/UploadFileUpcomingTrailers", data, { filename: filename, mimetype: mimetype });
  }
  public async ImportUpcomingTrailers(devices: string[], ) : Promise<boolean> {
      return await this.api.post<boolean>("Service/ImportUpcomingTrailers", null, { devices: devices });
  }
  public async GetLoggedInServicePartnerInfo() : Promise<x.ServicePartnerOverviewInfo> {
      return await this.api.get<x.ServicePartnerOverviewInfo>("Service/GetLoggedInServicePartnerInfo", {  });
  }
  public async GetLoggedInServiceGuyInfo() : Promise<x.ServicePartnerOverviewInfo> {
      return await this.api.get<x.ServicePartnerOverviewInfo>("Service/GetLoggedInServiceGuyInfo", {  });
  }
}
@Injectable({providedIn: 'root' })
export class T4TurboOrderService {
  constructor(private api: ApiService) {}
  public async ValidateOrgNo(orgNo: string, ) : Promise<string> {
      return await this.api.get<string>("TurboOrder/ValidateOrgNo", { orgNo: orgNo });
  }
  public async ResolveCustomer(id: number, orgno: string, ) : Promise<x.OrderCustomerModel> {
      return await this.api.get<x.OrderCustomerModel>("TurboOrder/ResolveCustomer", { id: id, orgno: orgno });
  }
  public async GetOrderCustomerInfo(customerId: number, ) : Promise<x.OrderCustomerInfo> {
      return await this.api.get<x.OrderCustomerInfo>("TurboOrder/GetOrderCustomerInfo", { customerId: customerId });
  }
  public async CancelTermination(rowId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/CancelTermination", { rowId: rowId });
  }
  public async CancelExtension(contractId: number, extensionId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/CancelExtension", { contractId: contractId, extensionId: extensionId });
  }
  public async CheckActiveContractExtensions(contractId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/CheckActiveContractExtensions", { contractId: contractId });
  }
  public async GetPendingContractExtensions(contractId: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetPendingContractExtensions", { contractId: contractId });
  }
  public async GetCustomer(id: number, ) : Promise<x.OrderCustomerModel> {
      return await this.api.get<x.OrderCustomerModel>("TurboOrder/GetCustomer", { id: id });
  }
  public async GetCustomerByCustomerNo(customerNo: string, isAxCustomerNumber: boolean, ) : Promise<x.OrderCustomerModel> {
      return await this.api.get<x.OrderCustomerModel>("TurboOrder/GetCustomerByCustomerNo", { customerNo: customerNo, isAxCustomerNumber: isAxCustomerNumber });
  }
  public async GetCustomers(onlyActive: boolean, ) : Promise<x.OrderCustomerModel[]> {
      return await this.api.get<x.OrderCustomerModel[]>("TurboOrder/GetCustomers", { onlyActive: onlyActive });
  }
  public async GetCustomersMissingPayThrough() : Promise<x.OrderCustomerModel[]> {
      return await this.api.get<x.OrderCustomerModel[]>("TurboOrder/GetCustomersMissingPayThrough", {  });
  }
  public async GetCustomersFromAnata(onlyActive: boolean, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetCustomersFromAnata", { onlyActive: onlyActive });
  }
  public async LoadMissingCustomersFromAnata() : Promise<any> {
      return await this.api.get<any>("TurboOrder/LoadMissingCustomersFromAnata", {  });
  }
  public async GetCustomersFromAnataById(customerAccount: string, ) : Promise<x.OrderCustomerModel> {
      return await this.api.get<x.OrderCustomerModel>("TurboOrder/GetCustomersFromAnataById", { customerAccount: customerAccount });
  }
  public async FilterCustomers(searchText: string, limit: number, servicePartner: boolean, ) : Promise<x.OrderCustomerModel[]> {
      return await this.api.get<x.OrderCustomerModel[]>("TurboOrder/FilterCustomers", { searchText: searchText, limit: limit, servicePartner: servicePartner });
  }
  public async FilterPricelists(searchText: string, limit: number, ) : Promise<x.ViewPriceListModel[]> {
      return await this.api.get<x.ViewPriceListModel[]>("TurboOrder/FilterPricelists", { searchText: searchText, limit: limit });
  }
  public async GetPricelists() : Promise<x.ViewPriceListModel[]> {
      return await this.api.get<x.ViewPriceListModel[]>("TurboOrder/GetPricelists", {  });
  }
  public async GetPricelistFromAnata() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetPricelistFromAnata", {  });
  }
  public async SavePricelist(pricelist: x.ViewPriceListModel) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/SavePricelist", pricelist, {  });
  }
  public async GetCustomersForHistoryFilter(searchText: string, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetCustomersForHistoryFilter", { searchText: searchText });
  }
  public async resendPendingOrders() : Promise<boolean> {
      return await this.api.put<boolean>("TurboOrder/resendPendingOrders", null, {  });
  }
  public async GetPriceList(id: number, ) : Promise<x.ViewPriceListModel> {
      return await this.api.get<x.ViewPriceListModel>("TurboOrder/GetPriceList", { id: id });
  }
  public async GetMyOrders() : Promise<x.RentalOrderSummary[]> {
      return await this.api.get<x.RentalOrderSummary[]>("TurboOrder/GetMyOrders", {  });
  }
  public async GetActiveOrders(customerId: number, ) : Promise<x.RentalOrderSummary[]> {
      return await this.api.get<x.RentalOrderSummary[]>("TurboOrder/GetActiveOrders", { customerId: customerId });
  }
  public async GetOldOrders() : Promise<x.RentalOrderSummary[]> {
      return await this.api.get<x.RentalOrderSummary[]>("TurboOrder/GetOldOrders", {  });
  }
  public async GetHistoricTrailersForCustomer(customerId: number, ) : Promise<x.RentalContractInfo[]> {
      return await this.api.get<x.RentalContractInfo[]>("TurboOrder/GetHistoricTrailersForCustomer", { customerId: customerId });
  }
  public async GetTrailerInspectionInfo() : Promise<x.TrailerInspectionInfo[]> {
      return await this.api.get<x.TrailerInspectionInfo[]>("TurboOrder/GetTrailerInspectionInfo", {  });
  }
  public async GetActiveContractForObject(objectId: number, ) : Promise<x.RentalContractInfo> {
      return await this.api.get<x.RentalContractInfo>("TurboOrder/GetActiveContractForObject", { objectId: objectId });
  }
  public async GetActiveTrailersForCustomer(customerId: number, ) : Promise<x.RentalContractInfo[]> {
      return await this.api.get<x.RentalContractInfo[]>("TurboOrder/GetActiveTrailersForCustomer", { customerId: customerId });
  }
  public async GetUsedStock(customerId: number, ) : Promise<x.VehicleInfo[]> {
      return await this.api.get<x.VehicleInfo[]>("TurboOrder/GetUsedStock", { customerId: customerId });
  }
  public async GetActiveContractInfo(contractId: number, ) : Promise<x.ActiveOrderModel> {
      return await this.api.get<x.ActiveOrderModel>("TurboOrder/GetActiveContractInfo", { contractId: contractId });
  }
  public async GetVehicleInfo(vehicleId: string, ) : Promise<x.VehicleInfo> {
      return await this.api.get<x.VehicleInfo>("TurboOrder/GetVehicleInfo", { vehicleId: vehicleId });
  }
  public async GetActiveContracts(vehicleId: string, ) : Promise<x.ActiveOrderModel[]> {
      return await this.api.get<x.ActiveOrderModel[]>("TurboOrder/GetActiveContracts", { vehicleId: vehicleId });
  }
  public async SetVehicleType(vehicleId: string, overrideItemId: string, ) : Promise<boolean> {
      return await this.api.put<boolean>("TurboOrder/SetVehicleType", null, { vehicleId: vehicleId, overrideItemId: overrideItemId });
  }
  public async CalculateResidualValue(contractId: number, terminationDate: moment.Moment, ) : Promise<number> {
      return await this.api.get<number>("TurboOrder/CalculateResidualValue", { contractId: contractId, terminationDate: terminationDate.toISOString() });
  }
  public async GetExpiringContracts(customerId: number, includeHandled: boolean, ) : Promise<x.RentalContractInfo[]> {
      return await this.api.get<x.RentalContractInfo[]>("TurboOrder/GetExpiringContracts", { customerId: customerId, includeHandled: includeHandled });
  }
  public async GetOrder(id: number, ) : Promise<x.ViewOrderModel> {
      return await this.api.get<x.ViewOrderModel>("TurboOrder/GetOrder", { id: id });
  }
  public async SendToDLL(orderId: number, validate: boolean, ) : Promise<string> {
      return await this.api.get<string>("TurboOrder/SendToDLL", { orderId: orderId, validate: validate });
  }
  public async SendToCustomerService(orderId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/SendToCustomerService", { orderId: orderId });
  }
  public async GetUsers() : Promise<x.UserDropDownModel[]> {
      return await this.api.get<x.UserDropDownModel[]>("TurboOrder/GetUsers", {  });
  }
  public async RentalReceipt(id: number, ) : Promise<string> {
      return await this.api.get<string>("TurboOrder/RentalReceipt", { id: id });
  }
  public async CreateTerminationOrder(id: number, ReceivingStationInvoiceEmail: string, IncomingContactPerson: string, SignatoryEmail: string, SignatoryName: string, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/CreateTerminationOrder", { id: id, ReceivingStationInvoiceEmail: ReceivingStationInvoiceEmail, IncomingContactPerson: IncomingContactPerson, SignatoryEmail: SignatoryEmail, SignatoryName: SignatoryName });
  }
  public async ResendTerminationOrder(id: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/ResendTerminationOrder", { id: id });
  }
  public async CreateNote(vehicleId: string, message: string, oldMessage: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/CreateNote", { vehicleId: vehicleId, message: message, oldMessage: oldMessage });
  }
  public async GetNotes(vehicleId: string, oldMessage: string, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetNotes", { vehicleId: vehicleId, oldMessage: oldMessage });
  }
  public async DeleteNote(vehicleId: string, noteId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/DeleteNote", { vehicleId: vehicleId, noteId: noteId });
  }
  public async MoveVehicle(vehicleId: string, customerId: number, positionDate: moment.Moment, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/MoveVehicle", { vehicleId: vehicleId, customerId: customerId, positionDate: positionDate.toISOString() });
  }
  public async ScrapVehicle(vehicleId: string, message: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/ScrapVehicle", { vehicleId: vehicleId, message: message });
  }
  public async MoveScraptoInStore(vehicleId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/MoveScraptoInStore", { vehicleId: vehicleId });
  }
  public async MoveSoldtoInStore(vehicleId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/MoveSoldtoInStore", { vehicleId: vehicleId });
  }
  public async RemovePurchase(vehicleId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/RemovePurchase", { vehicleId: vehicleId });
  }
  public async RemoveSale(vehicleId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/RemoveSale", { vehicleId: vehicleId });
  }
  public async SetSigned(orderId: number, ) : Promise<x.ViewOrderModel> {
      return await this.api.post<x.ViewOrderModel>("TurboOrder/SetSigned", null, { orderId: orderId });
  }
  public async Reactivate(orderId: number, ) : Promise<x.ViewOrderModel> {
      return await this.api.post<x.ViewOrderModel>("TurboOrder/Reactivate", null, { orderId: orderId });
  }
  public async SaveOrder(model: x.ViewOrderModel, ) : Promise<x.ViewOrderModel> {
      return await this.api.post<x.ViewOrderModel>("TurboOrder/SaveOrder", null, { model: model });
  }
  public async ForceRepurchase(vehicleId: string, ) : Promise<any> {
      return await this.api.put<any>("TurboOrder/ForceRepurchase", null, { vehicleId: vehicleId });
  }
  public async PostponeInvoice(orderIds: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/PostponeInvoice", { orderIds: orderIds });
  }
  public async InvoiceNow(orderIds: string, bypassStoppedInvoice: boolean, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/InvoiceNow", { orderIds: orderIds, bypassStoppedInvoice: bypassStoppedInvoice });
  }
  public async MoveUpInvoice(orderIds: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/MoveUpInvoice", { orderIds: orderIds });
  }
  public async MarkAsInvoiced(rowIds: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/MarkAsInvoiced", { rowIds: rowIds });
  }
  public async ExtendContract(contractId: number, newEndDate: moment.Moment, ) : Promise<string> {
      return await this.api.get<string>("TurboOrder/ExtendContract", { contractId: contractId, newEndDate: newEndDate.toISOString() });
  }
  public async SaveTermination(model: x.TerminationOrderInfo, ) : Promise<any> {
      return await this.api.post<any>("TurboOrder/SaveTermination", null, { model: model });
  }
  public async GetTerminations(customerId: number, ) : Promise<x.TerminationOrderInfo[]> {
      return await this.api.get<x.TerminationOrderInfo[]>("TurboOrder/GetTerminations", { customerId: customerId });
  }
  public async GetTermination(terminationId: number, ) : Promise<x.TerminationOrderInfo> {
      return await this.api.get<x.TerminationOrderInfo>("TurboOrder/GetTermination", { terminationId: terminationId });
  }
  public async CancelOrder(id: number, ) : Promise<x.ViewOrderModel> {
      return await this.api.post<x.ViewOrderModel>("TurboOrder/CancelOrder", null, { id: id });
  }
  public async SendToAx(id: number, ) : Promise<x.ViewOrderModel> {
      return await this.api.post<x.ViewOrderModel>("TurboOrder/SendToAx", null, { id: id });
  }
  public async ChecklistRepurchase(vehicleid: string, ) : Promise<x.ChecklistRepurchaseModel> {
      return await this.api.get<x.ChecklistRepurchaseModel>("TurboOrder/ChecklistRepurchase", { vehicleid: vehicleid });
  }
  public async ChecklistSold(vehicleid: string, ) : Promise<x.ChecklistSoldModel> {
      return await this.api.get<x.ChecklistSoldModel>("TurboOrder/ChecklistSold", { vehicleid: vehicleid });
  }
  public async ChecklistTermination(contractId: number, ) : Promise<x.ChecklistTerminationModel> {
      return await this.api.get<x.ChecklistTerminationModel>("TurboOrder/ChecklistTermination", { contractId: contractId });
  }
  public async GetIntegrationLogs(type: any, entityId: string, ) : Promise<x.IntegrationLogInfo[]> {
      return await this.api.get<x.IntegrationLogInfo[]>("TurboOrder/GetIntegrationLogs", { type: type, entityId: entityId });
  }
  public async CalculateOrderValue(monthlyCost: number, duration: number, countryCode: string, startDate: moment.Moment, paymentAtBeginning: boolean, residualValue: number, fake: boolean, ownership: string, ) : Promise<number> {
      return await this.api.get<number>("TurboOrder/CalculateOrderValue", { monthlyCost: monthlyCost, duration: duration, countryCode: countryCode, startDate: startDate.toISOString(), paymentAtBeginning: paymentAtBeginning, residualValue: residualValue, fake: fake, ownership: ownership });
  }
  public async GetCustomerSettings(customerId: number, ) : Promise<x.CustomerSettingsModel> {
      return await this.api.get<x.CustomerSettingsModel>("TurboOrder/GetCustomerSettings", { customerId: customerId });
  }
  public async SaveCustomerSettings(customerId: number, settings: x.CustomerSettingsModel) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/SaveCustomerSettings", settings, { customerId: customerId });
  }
  public async copyCustomerSettings(oldCustomerId: number, newCustomerId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/copyCustomerSettings", null, { oldCustomerId: oldCustomerId, newCustomerId: newCustomerId });
  }
  public async GetAllSubscriptions(contextId: string, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetAllSubscriptions", { contextId: contextId });
  }
  public async CreateSubscription(contextId: string, productId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/CreateSubscription", null, { contextId: contextId, productId: productId });
  }
  public async UpdateSubscription(subscription: x.SubscriptionInfo) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/UpdateSubscription", subscription, {  });
  }
  public async EndTransaction(contextId: string, id: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/EndTransaction", null, { contextId: contextId, id: id });
  }
  public async GetStakeholderCustomerRelations(customerId: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetStakeholderCustomerRelations", { customerId: customerId });
  }
  public async GetCustomerStakeolderRelations(customerId: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetCustomerStakeolderRelations", { customerId: customerId });
  }
  public async SaveStakeholderRelation(stakeholderId: number, customerId: number, percentile: number, ) : Promise<any> {
      return await this.api.post<any>("TurboOrder/SaveStakeholderRelation", null, { stakeholderId: stakeholderId, customerId: customerId, percentile: percentile });
  }
  public async DeleteStakeholderRelation(stakeholderId: number, customerId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("TurboOrder/DeleteStakeholderRelation", { stakeholderId: stakeholderId, customerId: customerId });
  }
  public async GetUnhandledExpiringContracts() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetUnhandledExpiringContracts", {  });
  }
  public async GetNoActionContracts() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetNoActionContracts", {  });
  }
  public async GetUsedStockTrailers() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetUsedStockTrailers", {  });
  }
  public async GetRepurchasePipe() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetRepurchasePipe", {  });
  }
  public async GetOffRentPipe() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetOffRentPipe", {  });
  }
  public async GetInvoicePipe() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetInvoicePipe", {  });
  }
  public async GetNotTerminated() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetNotTerminated", {  });
  }
  public async GetMyGarage() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetMyGarage", {  });
  }
  public async GetOrderValue12M() : Promise<number[]> {
      return await this.api.get<number[]>("TurboOrder/GetOrderValue12M", {  });
  }
  public async GetOrderedTrailerCount12M() : Promise<number[]> {
      return await this.api.get<number[]>("TurboOrder/GetOrderedTrailerCount12M", {  });
  }
  public async GetExpiringContracts12M() : Promise<number[]> {
      return await this.api.get<number[]>("TurboOrder/GetExpiringContracts12M", {  });
  }
  public async GetUsedSales12M() : Promise<number[]> {
      return await this.api.get<number[]>("TurboOrder/GetUsedSales12M", {  });
  }
  public async GetLocationStatistics() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetLocationStatistics", {  });
  }
  public async GetOrdetStatusStats() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetOrdetStatusStats", {  });
  }
  public async GetContractEvents(pricelist: string, from: moment.Moment, to: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetContractEvents", { pricelist: pricelist, from: from.toISOString(), to: to.toISOString() });
  }
  public async GetKPI(kpiId: string, from: moment.Moment, to: moment.Moment, ) : Promise<x.RentalKPI> {
      return await this.api.get<x.RentalKPI>("TurboOrder/GetKPI", { kpiId: kpiId, from: from.toISOString(), to: to.toISOString() });
  }
  public async SendPurchaseOrders() : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/SendPurchaseOrders", {  });
  }
  public async CreateT4Station(customerId: number, assignToId: number, ) : Promise<x.T4Result> {
      return await this.api.get<x.T4Result>("TurboOrder/CreateT4Station", { customerId: customerId, assignToId: assignToId });
  }
  public async UpdateT4Station(customerId: number, ) : Promise<x.T4Result> {
      return await this.api.get<x.T4Result>("TurboOrder/UpdateT4Station", { customerId: customerId });
  }
  public async AssignT4Station(customerId: number, stationId: number, ) : Promise<x.T4Result> {
      return await this.api.get<x.T4Result>("TurboOrder/AssignT4Station", { customerId: customerId, stationId: stationId });
  }
  public async DeactivateT4Station(customerId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/DeactivateT4Station", { customerId: customerId });
  }
  public async UpdateT4Object(contractId: number, ) : Promise<x.T4Result> {
      return await this.api.get<x.T4Result>("TurboOrder/UpdateT4Object", { contractId: contractId });
  }
  public async GetAllItems() : Promise<x.ItemOrderInfo[]> {
      return await this.api.get<x.ItemOrderInfo[]>("TurboOrder/GetAllItems", {  });
  }
  public async GetItemsForPricelist(pricelistId: number, ) : Promise<x.ItemOrderInfo[]> {
      return await this.api.get<x.ItemOrderInfo[]>("TurboOrder/GetItemsForPricelist", { pricelistId: pricelistId });
  }
  public async UpdateItem(item: any, ) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/UpdateItem", null, { item: item });
  }
  public async UpdateItems(items: any, ) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/UpdateItems", null, { items: items });
  }
  public async ImportItems(filename: string, mimetype: string, data: string) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/ImportItems", data, { filename: filename, mimetype: mimetype });
  }
  public async CreateGroup(name: string, parentId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/CreateGroup", null, { name: name, parentId: parentId });
  }
  public async UpdateT4Group(group: any, parentContextId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/UpdateT4Group", { group: group, parentContextId: parentContextId });
  }
  public async GetChains() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetChains", {  });
  }
  public async GetAllGroups() : Promise<x.T4ListItem[]> {
      return await this.api.get<x.T4ListItem[]>("TurboOrder/GetAllGroups", {  });
  }
  public async GetAllConceptGroups(includeChildren: boolean, ) : Promise<x.LocationGroupInfo[]> {
      return await this.api.get<x.LocationGroupInfo[]>("TurboOrder/GetAllConceptGroups", { includeChildren: includeChildren });
  }
  public async GetT4Groups() : Promise<x.T4ListItem[]> {
      return await this.api.get<x.T4ListItem[]>("TurboOrder/GetT4Groups", {  });
  }
  public async GetGroupMappings() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetGroupMappings", {  });
  }
  public async GetGroupMappingForPricelist(priceList: string, ) : Promise<number> {
      return await this.api.get<number>("TurboOrder/GetGroupMappingForPricelist", { priceList: priceList });
  }
  public async CreateGroupMapping(groupId: number, priceList: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/CreateGroupMapping", { groupId: groupId, priceList: priceList });
  }
  public async DeleteGroupMapping(groupId: number, priceList: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("TurboOrder/DeleteGroupMapping", { groupId: groupId, priceList: priceList });
  }
  public async SaveGroupMapping(groupId: number, priceList: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/SaveGroupMapping", { groupId: groupId, priceList: priceList });
  }
  public async GetT4GroupsWithinEntity() : Promise<x.T4ListItem[]> {
      return await this.api.get<x.T4ListItem[]>("TurboOrder/GetT4GroupsWithinEntity", {  });
  }
  public async GetContractMapOverview(chains: string, minContractCount: number, maxContractCount: number, expiresWithinMonths: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetContractMapOverview", { chains: chains, minContractCount: minContractCount, maxContractCount: maxContractCount, expiresWithinMonths: expiresWithinMonths });
  }
  public async GetContract(vehicleId: string, ) : Promise<x.RentalContractInfo> {
      return await this.api.get<x.RentalContractInfo>("TurboOrder/GetContract", { vehicleId: vehicleId });
  }
  public async AssembleRequestsForPreview(requestIds: any) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/AssembleRequestsForPreview", requestIds, {  });
  }
  public async AssembleRequestsForInvoicing(requestIds: any) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/AssembleRequestsForInvoicing", requestIds, {  });
  }
  public async ForgetInsuranceCases(requestIds: any) : Promise<boolean> {
      return await this.api.post<boolean>("TurboOrder/ForgetInsuranceCases", requestIds, {  });
  }
  public async GetInsuranceSetOff() : Promise<x.InsuranceSetOffLine[]> {
      return await this.api.get<x.InsuranceSetOffLine[]>("TurboOrder/GetInsuranceSetOff", {  });
  }
  public async GetProspect(id: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetProspect", { id: id });
  }
  public async GetAllProspects() : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetAllProspects", {  });
  }
  public async SaveNewProspect(id: number, latitude: any, longtitude: any, name: string, description: string, brand: string, ) : Promise<any> {
      return await this.api.post<any>("TurboOrder/SaveNewProspect", null, { id: id, latitude: latitude, longtitude: longtitude, name: name, description: description, brand: brand });
  }
  public async DeleteProspect(id: number, ) : Promise<any> {
      return await this.api.delete<any>("TurboOrder/DeleteProspect", { id: id });
  }
  public async SignPayThroughInvoices() : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/SignPayThroughInvoices", {  });
  }
  public async AnyUnsignedPTInvoices() : Promise<boolean> {
      return await this.api.get<boolean>("TurboOrder/AnyUnsignedPTInvoices", {  });
  }
  public async GetDeviceNumber(invoiceAccount: string, objectTitle: string, ) : Promise<number> {
      return await this.api.get<number>("TurboOrder/GetDeviceNumber", { invoiceAccount: invoiceAccount, objectTitle: objectTitle });
  }
  public async GetPendingEntityQueues() : Promise<x.EntityQueueInfo[]> {
      return await this.api.get<x.EntityQueueInfo[]>("TurboOrder/GetPendingEntityQueues", {  });
  }
  public async GetEntityEvents(entityId: string, entityType: any, eventType: number, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetEntityEvents", { entityId: entityId, entityType: entityType, eventType: eventType });
  }
  public async GetEntityAttachments(id: string, ) : Promise<any> {
      return await this.api.get<any>("TurboOrder/GetEntityAttachments", { id: id });
  }
  public async AddEntityEvent(entityId: string, entityType: any, message: string, eventType: number, ) : Promise<string> {
      return await this.api.get<string>("TurboOrder/AddEntityEvent", { entityId: entityId, entityType: entityType, message: message, eventType: eventType });
  }
}
@Injectable({providedIn: 'root' })
export class T4U4FDashboardService {
  constructor(private api: ApiService) {}
  public async GetU4FRevenuePreviousYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FRevenuePreviousYear", {  });
  }
  public async GetU4FRevenueCurrentYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FRevenueCurrentYear", {  });
  }
  public async GetU4FCountOfRentPreviousYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FCountOfRentPreviousYear", {  });
  }
  public async GetU4FCountOfRentCurrentYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FCountOfRentCurrentYear", {  });
  }
  public async GetU4FAverageIncomeCurrentYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FAverageIncomeCurrentYear", {  });
  }
  public async GetU4FAverageIncomePreviousYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FAverageIncomePreviousYear", {  });
  }
  public async GetU4FFreeInsuranceAndPreBookingCurrentYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FFreeInsuranceAndPreBookingCurrentYear", {  });
  }
  public async GetU4FFreeInsuranceAndPreBookingPreviousYear() : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FFreeInsuranceAndPreBookingPreviousYear", {  });
  }
  public async GetU4FExecutiveSummary(start: moment.Moment, end: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("U4FDashboard/GetU4FExecutiveSummary", { start: start.toISOString(), end: end.toISOString() });
  }
}
@Injectable({providedIn: 'root' })
export class T4WebHookSettingsService {
  constructor(private api: ApiService) {}
  public async GetWebHookSettings() : Promise<any> {
      return await this.api.get<any>("WebHookSettings/GetWebHookSettings", {  });
  }
  public async SaveWebHookSetting(setting: x.T4SettingsPage) : Promise<boolean> {
      return await this.api.post<boolean>("WebHookSettings/SaveWebHookSetting", setting, {  });
  }
}
@Injectable({providedIn: 'root' })
export class T4NotificationService {
  constructor(private api: ApiService) {}
  public async GetNotificationSettings() : Promise<x.QueuedMessageSettingInfo[]> {
      return await this.api.get<x.QueuedMessageSettingInfo[]>("Notification/GetNotificationSettings", {  });
  }
  public async GetNotificationSetting(id: string, ) : Promise<x.QueuedMessageSettingInfo> {
      return await this.api.get<x.QueuedMessageSettingInfo>("Notification/GetNotificationSetting", { id: id });
  }
  public async SaveNotificationSetting(info: x.QueuedMessageSettingInfo) : Promise<any> {
      return await this.api.post<any>("Notification/SaveNotificationSetting", info, {  });
  }
  public async AddQueuedMessages(contextId: string, userId: string, rentalId: number, receiverPhone: string, receiverEmail: string, ) : Promise<any> {
      return await this.api.post<any>("Notification/AddQueuedMessages", null, { contextId: contextId, userId: userId, rentalId: rentalId, receiverPhone: receiverPhone, receiverEmail: receiverEmail });
  }
  public async GetNotificationAudienceCount(category: any, conditions: x.QueuedMessageAudienceConditionInfo[]) : Promise<number> {
      return await this.api.post<number>("Notification/GetNotificationAudienceCount", conditions, { category: category });
  }
  public async AddDirectQueuedMessage(info: x.DirectQueuedMessageInfo) : Promise<boolean> {
      return await this.api.post<boolean>("Notification/AddDirectQueuedMessage", info, {  });
  }
}
@Injectable({providedIn: 'root' })
export class T4AvailabilityService {
  constructor(private api: ApiService) {}
  public async GetLocationsByCity(city: string, ) : Promise<any> {
      return await this.api.get<any>("Availability/GetLocationsByCity", { city: city });
  }
  public async GetLocationsById(locationIds: string, ) : Promise<any> {
      return await this.api.get<any>("Availability/GetLocationsById", { locationIds: locationIds });
  }
  public async GetLocationsByModel(modelIds: string, city: string, ) : Promise<any> {
      return await this.api.get<any>("Availability/GetLocationsByModel", { modelIds: modelIds, city: city });
  }
  public async GetObjectByAlias(alias: string, ) : Promise<any> {
      return await this.api.get<any>("Availability/GetObjectByAlias", { alias: alias });
  }
  public async GetObjectByRegNo(regNo: string, ) : Promise<any> {
      return await this.api.get<any>("Availability/GetObjectByRegNo", { regNo: regNo });
  }
  public async GetObjectById(id: any, ) : Promise<any> {
      return await this.api.get<any>("Availability/GetObjectById", { id: id });
  }
}
@Injectable({providedIn: 'root' })
export class T4CampaignService {
  constructor(private api: ApiService) {}
  public async ValidateDiscount(code: string, pickupTime: moment.Moment, returnTime: moment.Moment, pickupLocationId: number, returnLocationId: number, objectTypeId: number, createdAt: moment.Moment, isWebBooking: boolean, isOneWay: boolean, newRequest: boolean, addedProducts: string, customerId: number, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Campaign/ValidateDiscount", { code: code, pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), pickupLocationId: pickupLocationId, returnLocationId: returnLocationId, objectTypeId: objectTypeId, createdAt: createdAt.toISOString(), isWebBooking: isWebBooking, isOneWay: isOneWay, newRequest: newRequest, addedProducts: addedProducts, customerId: customerId });
  }
  public async GetActiveCampaigns() : Promise<any> {
      return await this.api.get<any>("Campaign/GetActiveCampaigns", {  });
  }
  public async GetActivePartnerCampaigns() : Promise<any> {
      return await this.api.get<any>("Campaign/GetActivePartnerCampaigns", {  });
  }
  public async GetArchivedPartnerCampaigns() : Promise<any> {
      return await this.api.get<any>("Campaign/GetArchivedPartnerCampaigns", {  });
  }
  public async GetPartnerCampaignData(discountCode: string, ) : Promise<any> {
      return await this.api.get<any>("Campaign/GetPartnerCampaignData", { discountCode: discountCode });
  }
  public async GetCreatedCampaignData12M(discountCode: string, ) : Promise<number[]> {
      return await this.api.get<number[]>("Campaign/GetCreatedCampaignData12M", { discountCode: discountCode });
  }
  public async GetUsedCampaignData12M(discountCode: string, ) : Promise<number[]> {
      return await this.api.get<number[]>("Campaign/GetUsedCampaignData12M", { discountCode: discountCode });
  }
  public async ActivatePartnerCampaign(discountCode: string, ) : Promise<string> {
      return await this.api.get<string>("Campaign/ActivatePartnerCampaign", { discountCode: discountCode });
  }
  public async ActivatePartnerCampaignView(discountCode: string, ) : Promise<string> {
      return await this.api.get<string>("Campaign/ActivatePartnerCampaignView", { discountCode: discountCode });
  }
  public async GetTemplates() : Promise<any> {
      return await this.api.get<any>("Campaign/GetTemplates", {  });
  }
  public async GetUserCampaigns() : Promise<any> {
      return await this.api.get<any>("Campaign/GetUserCampaigns", {  });
  }
  public async GetSingleDiscount() : Promise<any> {
      return await this.api.get<any>("Campaign/GetSingleDiscount", {  });
  }
  public async GetArchivedCampaigns() : Promise<any> {
      return await this.api.get<any>("Campaign/GetArchivedCampaigns", {  });
  }
  public async GenerateDiscountCode() : Promise<string> {
      return await this.api.get<string>("Campaign/GenerateDiscountCode", {  });
  }
  public async GetCampaignInfo(campaignID: string, ) : Promise<x.CampaignInfo> {
      return await this.api.get<x.CampaignInfo>("Campaign/GetCampaignInfo", { campaignID: campaignID });
  }
  public async GetCampaignOfferInfo(discountId: string, ) : Promise<x.CampaignInfo> {
      return await this.api.get<x.CampaignInfo>("Campaign/GetCampaignOfferInfo", { discountId: discountId });
  }
  public async CheckActivePopupCampaign(triggerAction: number, bookingId: any, country: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Campaign/CheckActivePopupCampaign", { triggerAction: triggerAction, bookingId: bookingId, country: country });
  }
  public async OfferClicked(discountId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Campaign/OfferClicked", { discountId: discountId });
  }
  public async GetSubCampaigns(parentCode: string, ) : Promise<any> {
      return await this.api.get<any>("Campaign/GetSubCampaigns", { parentCode: parentCode });
  }
  public async GetBookingsForCampaign(parentCode: string, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Campaign/GetBookingsForCampaign", { parentCode: parentCode });
  }
  public async GetDiscount(code: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Campaign/GetDiscount", { code: code });
  }
  public async CreateDiscount(value: number, type: any, reasonId: string, comment: string, pickupLocationId: number, isOneWay: boolean, ) : Promise<x.DiscountModel> {
      return await this.api.post<x.DiscountModel>("Campaign/CreateDiscount", null, { value: value, type: type, reasonId: reasonId, comment: comment, pickupLocationId: pickupLocationId, isOneWay: isOneWay });
  }
  public async CreateCampaign(campaignValues: x.CampaignInfo) : Promise<x.CampaignInfo> {
      return await this.api.post<x.CampaignInfo>("Campaign/CreateCampaign", campaignValues, {  });
  }
  public async SendVoucherToUser(templateCode: string, customerId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Campaign/SendVoucherToUser", { templateCode: templateCode, customerId: customerId });
  }
  public async CalculateSMSAmount(groups: string, stations: string, fromDate: moment.Moment, toDate: moment.Moment, ) : Promise<number> {
      return await this.api.get<number>("Campaign/CalculateSMSAmount", { groups: groups, stations: stations, fromDate: fromDate.toISOString(), toDate: toDate.toISOString() });
  }
  public async GenerateVouchers(templateCode: string, amount: number, value: number, valueType: any, partner: string, ) : Promise<x.GenerateVoucherResult> {
      return await this.api.get<x.GenerateVoucherResult>("Campaign/GenerateVouchers", { templateCode: templateCode, amount: amount, value: value, valueType: valueType, partner: partner });
  }
  public async GenerateVoucher(templateCode: string, ) : Promise<x.GenerateVoucherResult> {
      return await this.api.get<x.GenerateVoucherResult>("Campaign/GenerateVoucher", { templateCode: templateCode });
  }
  public async UpdateCampaign(campaignValues: x.CampaignInfo) : Promise<boolean> {
      return await this.api.post<boolean>("Campaign/UpdateCampaign", campaignValues, {  });
  }
  public async FindCampaigns(keywords: string, minLength: number, ) : Promise<any> {
      return await this.api.get<any>("Campaign/FindCampaigns", { keywords: keywords, minLength: minLength });
  }
  public async GenerateCoupon(templateCode: string, referenceRentalId: number, batchId: string, value: number, valueType: any, partner: string, savePdf: boolean, customer: any, daysValid: number, partnerCompaign: boolean, bookingReference: any, ) : Promise<x.DiscountModel> {
      return await this.api.post<x.DiscountModel>("Campaign/GenerateCoupon", null, { templateCode: templateCode, referenceRentalId: referenceRentalId, batchId: batchId, value: value, valueType: valueType, partner: partner, savePdf: savePdf, customer: customer, daysValid: daysValid, partnerCompaign: partnerCompaign, bookingReference: bookingReference });
  }
  public async GetDiscountReasons(isOneWay: boolean, ) : Promise<any> {
      return await this.api.get<any>("Campaign/GetDiscountReasons", { isOneWay: isOneWay });
  }
  public async CheckActiveInviteFriendsCampaign(triggerAction: number, isCustomerContext: boolean, userLoggedIn: boolean, bookingId: any, country: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Campaign/CheckActiveInviteFriendsCampaign", { triggerAction: triggerAction, isCustomerContext: isCustomerContext, userLoggedIn: userLoggedIn, bookingId: bookingId, country: country });
  }
  public async GenerateCouponForInviteFriends(isCustomerContext: boolean, userLoggedIn: boolean, bookingId: any, country: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Campaign/GenerateCouponForInviteFriends", { isCustomerContext: isCustomerContext, userLoggedIn: userLoggedIn, bookingId: bookingId, country: country });
  }
  public async GenerateCouponForInviteFriend(isCustomerContext: boolean, userLoggedIn: boolean, bookingId: any, country: string, campaignId: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Campaign/GenerateCouponForInviteFriend", { isCustomerContext: isCustomerContext, userLoggedIn: userLoggedIn, bookingId: bookingId, country: country, campaignId: campaignId });
  }
}
@Injectable({providedIn: 'root' })
export class T4CustomerService {
  constructor(private api: ApiService) {}
  public async FindCustomer(customerIdentification: string, type: any, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Customer/FindCustomer", { customerIdentification: customerIdentification, type: type });
  }
  public async FindCustomer1(customerIdentification: string, type: any, isOneWay: boolean, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Customer/FindCustomer", { customerIdentification: customerIdentification, type: type, isOneWay: isOneWay });
  }
  public async LookupCustomer(ssn: string, type: any, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Customer/LookupCustomer", { ssn: ssn, type: type });
  }
  public async GetCustomer(customerId: any, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Customer/GetCustomer", { customerId: customerId });
  }
  public async GetOneWayCustomers() : Promise<any> {
      return await this.api.get<any>("Customer/GetOneWayCustomers", {  });
  }
  public async GetCustomers() : Promise<x.CustomerInfo[]> {
      return await this.api.get<x.CustomerInfo[]>("Customer/GetCustomers", {  });
  }
  public async FindCustomerByUser(userId: string, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Customer/FindCustomerByUser", { userId: userId });
  }
  public async SaveCustomer(customer: x.CustomerInfo, ) : Promise<x.CustomerInfo> {
      return await this.api.post<x.CustomerInfo>("Customer/SaveCustomer", null, { customer: customer });
  }
  public async SaveCustomer1(customer: x.CustomerInfo, isOneWay: boolean, ) : Promise<x.CustomerInfo> {
      return await this.api.post<x.CustomerInfo>("Customer/SaveCustomer", null, { customer: customer, isOneWay: isOneWay });
  }
  public async DeleteCustomerData(input: x.CustomerInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Customer/DeleteCustomerData", null, { input: input });
  }
  public async AddRelation(parentId: any, childId: any, ) : Promise<any> {
      return await this.api.post<any>("Customer/AddRelation", null, { parentId: parentId, childId: childId });
  }
  public async RemoveRelation(parentId: any, childId: any, ) : Promise<any> {
      return await this.api.delete<any>("Customer/RemoveRelation", { parentId: parentId, childId: childId });
  }
  public async GetRelations(parentId: any, ) : Promise<x.CustomerInfo[]> {
      return await this.api.get<x.CustomerInfo[]>("Customer/GetRelations", { parentId: parentId });
  }
}
@Injectable({providedIn: 'root' })
export class T4CustomerServiceService {
  constructor(private api: ApiService) {}
  public async FindRental(customerEmail: string, brand: string, ) : Promise<x.RentalInfo> {
      return await this.api.get<x.RentalInfo>("CustomerService/FindRental", { customerEmail: customerEmail, brand: brand });
  }
  public async RemoveOneWayDelay(rentalId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("CustomerService/RemoveOneWayDelay", { rentalId: rentalId });
  }
}
@Injectable({providedIn: 'root' })
export class T4MessagingService {
  constructor(private api: ApiService) {}
  public async GetRandom() : Promise<x.MessageModel> {
      return await this.api.get<x.MessageModel>("Messaging/GetRandom", {  });
  }
  public async GetBannerMessages(clientVersion: string, ) : Promise<x.MessageModel[]> {
      return await this.api.get<x.MessageModel[]>("Messaging/GetBannerMessages", { clientVersion: clientVersion });
  }
  public async GetPriorityMessages(clientVersion: string, ) : Promise<x.MessageModel[]> {
      return await this.api.get<x.MessageModel[]>("Messaging/GetPriorityMessages", { clientVersion: clientVersion });
  }
  public async GetNextSystemMessage(clientVersion: string, ) : Promise<x.MessageModel> {
      return await this.api.get<x.MessageModel>("Messaging/GetNextSystemMessage", { clientVersion: clientVersion });
  }
  public async GetInboxMessages() : Promise<x.MessageModel[]> {
      return await this.api.get<x.MessageModel[]>("Messaging/GetInboxMessages", {  });
  }
  public async GetConceptInfo() : Promise<x.ConceptModel> {
      return await this.api.get<x.ConceptModel>("Messaging/GetConceptInfo", {  });
  }
  public async RegisterRead(messageId: string, response: string) : Promise<any> {
      return await this.api.post<any>("Messaging/RegisterRead", response, { messageId: messageId });
  }
  public async GetReceivers(search: string, ) : Promise<any> {
      return await this.api.get<any>("Messaging/GetReceivers", { search: search });
  }
  public async Send(receivers: x.Receiver[], subject: string, content: string, ) : Promise<any> {
      return await this.api.get<any>("Messaging/Send", { receivers: receivers, subject: subject, content: content });
  }
  public async PlaceMessage(subject: string, content: string, language: string, validFrom: moment.Moment, validTo: moment.Moment, priority: any, requireConfirmation: boolean, receivers: x.Receiver[]) : Promise<boolean> {
      return await this.api.post<boolean>("Messaging/PlaceMessage", receivers, { subject: subject, content: content, language: language, validFrom: validFrom.toISOString(), validTo: validTo.toISOString(), priority: priority, requireConfirmation: requireConfirmation });
  }
  public async SendSms(rentalId: number, message: string, ) : Promise<string> {
      return await this.api.post<string>("Messaging/SendSms", null, { rentalId: rentalId, message: message });
  }
  public async SendMailServiceGuy(serviceGuyId: string, message: string, requestId: number, ) : Promise<string> {
      return await this.api.post<string>("Messaging/SendMailServiceGuy", null, { serviceGuyId: serviceGuyId, message: message, requestId: requestId });
  }
}
@Injectable({providedIn: 'root' })
export class T4PriceService {
  constructor(private api: ApiService) {}
  public async GetPriceOverview(typeId: number, ) : Promise<x.IntervalPrice[]> {
      return await this.api.get<x.IntervalPrice[]>("Price/GetPriceOverview", { typeId: typeId });
  }
  public async GetPriceInfo(pickupTime: moment.Moment, objectType: number, webBooking: boolean, isOneWay: boolean, ) : Promise<x.PriceInfoModel> {
      return await this.api.get<x.PriceInfoModel>("Price/GetPriceInfo", { pickupTime: pickupTime.toISOString(), objectType: objectType, webBooking: webBooking, isOneWay: isOneWay });
  }
  public async GetPriceInfo1(pickupTime: moment.Moment, pickupLocationId: number, objectType: number, webBooking: boolean, isOneWay: boolean, ) : Promise<x.PriceInfoModel> {
      return await this.api.get<x.PriceInfoModel>("Price/GetPriceInfo", { pickupTime: pickupTime.toISOString(), pickupLocationId: pickupLocationId, objectType: objectType, webBooking: webBooking, isOneWay: isOneWay });
  }
  public async GetRentalCost(id: any, ) : Promise<x.PriceModel> {
      return await this.api.get<x.PriceModel>("Price/GetRentalCost", { id: id });
  }
  public async ValidateDiscount(code: string, pickupTime: moment.Moment, returnTime: moment.Moment, pickupLocationId: number, returnLocationId: number, objectTypeId: number, createdAt: moment.Moment, isWebBooking: boolean, isOneWay: boolean, newRequest: boolean, addedProducts: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Price/ValidateDiscount", { code: code, pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), pickupLocationId: pickupLocationId, returnLocationId: returnLocationId, objectTypeId: objectTypeId, createdAt: createdAt.toISOString(), isWebBooking: isWebBooking, isOneWay: isOneWay, newRequest: newRequest, addedProducts: addedProducts });
  }
  public async GetDiscount(code: string, ) : Promise<x.DiscountModel> {
      return await this.api.get<x.DiscountModel>("Price/GetDiscount", { code: code });
  }
  public async CreateDiscount(value: number, type: any, reasonId: string, comment: string, pickupLocationId: number, isOneWay: boolean, ) : Promise<x.DiscountModel> {
      return await this.api.post<x.DiscountModel>("Price/CreateDiscount", null, { value: value, type: type, reasonId: reasonId, comment: comment, pickupLocationId: pickupLocationId, isOneWay: isOneWay });
  }
  public async GetRentalPrice(pickupTime: moment.Moment, returnTime: moment.Moment, objectTypeId: number, pickupLocationId: any, discountId: string, addons: string, includeDefaultAddons: boolean, customerId: number, userId: string, bookingLat: number, bookingLng: number, isOneWay: boolean, ) : Promise<x.PriceModel> {
      return await this.api.get<x.PriceModel>("Price/GetRentalPrice", { pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), objectTypeId: objectTypeId, pickupLocationId: pickupLocationId, discountId: discountId, addons: addons, includeDefaultAddons: includeDefaultAddons, customerId: customerId, userId: userId, bookingLat: bookingLat, bookingLng: bookingLng, isOneWay: isOneWay });
  }
  public async GetRentalPrice1(pickupTime: moment.Moment, returnTime: moment.Moment, objectTypeId: number, pickupLocationId: number, returnLocationId: number, useInsurance: boolean, webBooking: boolean, createdAt: moment.Moment, actualReturnTime: moment.Moment, discountId: string, addedProducts: string, includeDefaultAddons: boolean, customerId: number, userId: string, bookingLat: number, bookingLng: number, isOneWay: boolean, useCurrentContext: boolean, ) : Promise<x.PriceModel> {
      return await this.api.get<x.PriceModel>("Price/GetRentalPrice", { pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), objectTypeId: objectTypeId, pickupLocationId: pickupLocationId, returnLocationId: returnLocationId, useInsurance: useInsurance, webBooking: webBooking, createdAt: createdAt.toISOString(), actualReturnTime: actualReturnTime.toISOString(), discountId: discountId, addedProducts: addedProducts, includeDefaultAddons: includeDefaultAddons, customerId: customerId, userId: userId, bookingLat: bookingLat, bookingLng: bookingLng, isOneWay: isOneWay, useCurrentContext: useCurrentContext });
  }
  public async GetAddonPriceInfo(addonId: number, ) : Promise<x.IntervalPrice> {
      return await this.api.get<x.IntervalPrice>("Price/GetAddonPriceInfo", { addonId: addonId });
  }
  public async GetFromPrice(categoryId: string, locationId: number, ) : Promise<number> {
      return await this.api.get<number>("Price/GetFromPrice", { categoryId: categoryId, locationId: locationId });
  }
  public async GetFromPriceByObject(objectTypeId: number, locationId: number, includeDefaultAddons: boolean, ) : Promise<number> {
      return await this.api.get<number>("Price/GetFromPriceByObject", { objectTypeId: objectTypeId, locationId: locationId, includeDefaultAddons: includeDefaultAddons });
  }
  public async GetItemPrice(objectTypeId: number, ) : Promise<number> {
      return await this.api.get<number>("Price/GetItemPrice", { objectTypeId: objectTypeId });
  }
  public async AddCost(itemId: number, amount: number, description: string, rentalId: any, isHidden: boolean, ) : Promise<boolean> {
      return await this.api.post<boolean>("Price/AddCost", null, { itemId: itemId, amount: amount, description: description, rentalId: rentalId, isHidden: isHidden });
  }
  public async CancelCost(costId: number, description: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Price/CancelCost", null, { costId: costId, description: description });
  }
}
@Injectable({providedIn: 'root' })
export class T4RentalLocationService {
  constructor(private api: ApiService) {}
  public async GetLocationInfo(locationId: number, ) : Promise<x.LocationInfo> {
      return await this.api.get<x.LocationInfo>("Location/GetLocationInfo", { locationId: locationId });
  }
  public async GetInvoiceAddress(locationId: number, ) : Promise<any> {
      return await this.api.get<any>("Location/GetInvoiceAddress", { locationId: locationId });
  }
  public async GetServiceLocation(locationId: number, ) : Promise<x.ServiceLocationInfo> {
      return await this.api.get<x.ServiceLocationInfo>("Location/GetServiceLocation", { locationId: locationId });
  }
  public async GetAvailableLocations(isOneway: boolean, includeService: boolean, ) : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/GetAvailableLocations", { isOneway: isOneway, includeService: includeService });
  }
  public async GetLocations(subcontext: string, withCategories: boolean, isT4Mobile: boolean, ) : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/GetLocations", { subcontext: subcontext, withCategories: withCategories, isT4Mobile: isT4Mobile });
  }
  public async GetLocationsNoFilter() : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/GetLocationsNoFilter", {  });
  }
  public async GetLocationInformation(contextId: string, ) : Promise<any> {
      return await this.api.get<any>("Location/GetLocationInformation", { contextId: contextId });
  }
  public async GetLocationModelsWithAttributes(contextId: string, ) : Promise<string> {
      return await this.api.get<string>("Location/GetLocationModelsWithAttributes", { contextId: contextId });
  }
  public async GetChildGroups() : Promise<any> {
      return await this.api.get<any>("Location/GetChildGroups", {  });
  }
  public async GetGroupLocationHierarchy() : Promise<x.GroupLocationHierarchyInfo> {
      return await this.api.get<x.GroupLocationHierarchyInfo>("Location/GetGroupLocationHierarchy", {  });
  }
  public async GetLocationsWithAvailable(categoryId: string, subcontext: string, ) : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/GetLocationsWithAvailable", { categoryId: categoryId, subcontext: subcontext });
  }
  public async FindLocations(latitude: any, longitude: any, maxDistance: number, subcontext: string, ) : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/FindLocations", { latitude: latitude, longitude: longitude, maxDistance: maxDistance, subcontext: subcontext });
  }
  public async FilterLocations(searchText: string, limit: number, ) : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/FilterLocations", { searchText: searchText, limit: limit });
  }
  public async FindClosestLocations(latitude: any, longitude: any, maxDistance: number, ) : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Location/FindClosestLocations", { latitude: latitude, longitude: longitude, maxDistance: maxDistance });
  }
  public async GetAlternateLocations(locationId: any, categoryId: string, pickupTime: any, returnTime: any, ) : Promise<x.BookingAlternative[]> {
      return await this.api.get<x.BookingAlternative[]>("Location/GetAlternateLocations", { locationId: locationId, categoryId: categoryId, pickupTime: pickupTime, returnTime: returnTime });
  }
  public async GetOpenHoursForPeriod(locationId: any, startDate: any, endDate: any, ) : Promise<x.OpenHours[]> {
      return await this.api.get<x.OpenHours[]>("Location/GetOpenHoursForPeriod", { locationId: locationId, startDate: startDate, endDate: endDate });
  }
  public async GetOpenHours(locationId: any, date: any, ) : Promise<x.OpenHours> {
      return await this.api.get<x.OpenHours>("Location/GetOpenHours", { locationId: locationId, date: date });
  }
  public async GetOpenHoursForEdit() : Promise<x.OpenHourSetting[]> {
      return await this.api.get<x.OpenHourSetting[]>("Location/GetOpenHoursForEdit", {  });
  }
  public async UpdateOpenHours(dayOfWeek: number, specificDate: moment.Moment, opens: any, closes: any, closed: boolean, ) : Promise<any> {
      return await this.api.post<any>("Location/UpdateOpenHours", null, { dayOfWeek: dayOfWeek, specificDate: specificDate.toISOString(), opens: opens, closes: closes, closed: closed });
  }
  public async ClearOpenHours(dayOfWeek: number, specificDate: moment.Moment, ) : Promise<any> {
      return await this.api.post<any>("Location/ClearOpenHours", null, { dayOfWeek: dayOfWeek, specificDate: specificDate.toISOString() });
  }
  public async UpdateLocationUser(userId: number, firstname: string, lastname: string, phone: string, email: string, pincode: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Location/UpdateLocationUser", null, { userId: userId, firstname: firstname, lastname: lastname, phone: phone, email: email, pincode: pincode });
  }
  public async CreateLocationUser(firstname: string, lastname: string, phone: string, email: string, pincode: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Location/CreateLocationUser", null, { firstname: firstname, lastname: lastname, phone: phone, email: email, pincode: pincode });
  }
  public async DeleteLocationUser(userId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Location/DeleteLocationUser", null, { userId: userId });
  }
}
@Injectable({providedIn: 'root' })
export class T4RentalObjectService {
  constructor(private api: ApiService) {}
  public async GetObjectFamiliesAsync() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetObjectFamiliesAsync", {  });
  }
  public async GetFamiliesAtLocation(locationId: any, ) : Promise<x.TypeCategoryInfo[]> {
      return await this.api.get<x.TypeCategoryInfo[]>("RentalObject/GetFamiliesAtLocation", { locationId: locationId });
  }
  public async GetFamilyForType(objectTypeId: number, ) : Promise<x.TypeCategoryInfo> {
      return await this.api.get<x.TypeCategoryInfo>("RentalObject/GetFamilyForType", { objectTypeId: objectTypeId });
  }
  public async GetTypeCategories() : Promise<x.TypeCategoryInfo[]> {
      return await this.api.get<x.TypeCategoryInfo[]>("RentalObject/GetTypeCategories", {  });
  }
  public async GetTypeCategoriesForEdit() : Promise<x.TypeCategoryInfo[]> {
      return await this.api.get<x.TypeCategoryInfo[]>("RentalObject/GetTypeCategoriesForEdit", {  });
  }
  public async SaveCategory(category: x.TypeCategoryInfo) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/SaveCategory", category, {  });
  }
  public async SaveCategoryForType(catId: string, typeId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/SaveCategoryForType", { catId: catId, typeId: typeId });
  }
  public async DeleteCategoryConnectionForType(typeId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/DeleteCategoryConnectionForType", { typeId: typeId });
  }
  public async DeleteCategory(categoryId: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("RentalObject/DeleteCategory", { categoryId: categoryId });
  }
  public async GetTypesInCategory(categoryId: number, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetTypesInCategory", { categoryId: categoryId });
  }
  public async GetTypeCategoryId(objectTypeId: number, ) : Promise<number> {
      return await this.api.get<number>("RentalObject/GetTypeCategoryId", { objectTypeId: objectTypeId });
  }
  public async GetTypeCategory(objectTypeId: number, ) : Promise<x.TypeCategoryInfo> {
      return await this.api.get<x.TypeCategoryInfo>("RentalObject/GetTypeCategory", { objectTypeId: objectTypeId });
  }
  public async GetTypesAtLocation(location: any, oneway: boolean, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetTypesAtLocation", { location: location, oneway: oneway });
  }
  public async GetAllTypes(type: any, requirePrefix: boolean, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetAllTypes", { type: type, requirePrefix: requirePrefix });
  }
  public async GetMyTypes(type: any, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetMyTypes", { type: type });
  }
  public async GetTypes(type: any, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetTypes", { type: type });
  }
  public async GetChildTypes(type: any, childId: number, ) : Promise<any> {
      return await this.api.get<any>("RentalObject/GetChildTypes", { type: type, childId: childId });
  }
  public async GetActiveTypesAtLocation(location: any, oneway: boolean, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetActiveTypesAtLocation", { location: location, oneway: oneway });
  }
  public async GetActiveTypesAtLocationInCategory(location: any, categoryId: string, oneway: boolean, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetActiveTypesAtLocationInCategory", { location: location, categoryId: categoryId, oneway: oneway });
  }
  public async GetTypeInfo(objectType: number, ) : Promise<x.ObjectTypeInfo> {
      return await this.api.get<x.ObjectTypeInfo>("RentalObject/GetTypeInfo", { objectType: objectType });
  }
  public async GetAddons(typeId: number, locationId: number, ) : Promise<any> {
      return await this.api.get<any>("RentalObject/GetAddons", { typeId: typeId, locationId: locationId });
  }
  public async GetAllAddons() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetAllAddons", {  });
  }
  public async GetAllSpareparts() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetAllSpareparts", {  });
  }
  public async SaveAddon(a: x.ObjectTypeInfo, type: any, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/SaveAddon", null, { a: a, type: type });
  }
  public async SaveObjectType(a: x.ObjectTypeInfo, ) : Promise<number> {
      return await this.api.post<number>("RentalObject/SaveObjectType", null, { a: a });
  }
  public async DeleteAddon(id: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("RentalObject/DeleteAddon", { id: id });
  }
  public async GetNearByOptions(locationId: any, categoryId: string, pickupTime: moment.Moment, returnTime: moment.Moment, bookingId: number, ) : Promise<x.FindNearByOptionsResult> {
      return await this.api.get<x.FindNearByOptionsResult>("RentalObject/GetNearByOptions", { locationId: locationId, categoryId: categoryId, pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), bookingId: bookingId });
  }
  public async GetAvailableTypes(locationId: any, categoryId: string, pickupTime: moment.Moment, returnTime: moment.Moment, bookingId: number, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetAvailableTypes", { locationId: locationId, categoryId: categoryId, pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), bookingId: bookingId });
  }
  public async FindAvailableTypes(bookingId: number, query: x.FindTypesQuery) : Promise<x.FindTypesResults[]> {
      return await this.api.post<x.FindTypesResults[]>("RentalObject/FindAvailableTypes", query, { bookingId: bookingId });
  }
  public async GetAvailableTypes1(location: any, categoryId: string, pickupTime: moment.Moment, returnTime: moment.Moment, ignoreRentalId: number, oneway: boolean, ) : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetAvailableTypes", { location: location, categoryId: categoryId, pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), ignoreRentalId: ignoreRentalId, oneway: oneway });
  }
  public async GetAvailableRentalObjects(location: any, pickupTime: moment.Moment, returnTime: moment.Moment, ignoreRentalId: number, oneway: boolean, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetAvailableRentalObjects", { location: location, pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), ignoreRentalId: ignoreRentalId, oneway: oneway });
  }
  public async GetObjectInfo(objectId: any, ) : Promise<x.RentalObjectInfo> {
      return await this.api.get<x.RentalObjectInfo>("RentalObject/GetObjectInfo", { objectId: objectId });
  }
  public async GetGPSLockHistoryInfo(lockId: string, ) : Promise<any> {
      return await this.api.get<any>("RentalObject/GetGPSLockHistoryInfo", { lockId: lockId });
  }
  public async GetGpsTrailers() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetGpsTrailers", {  });
  }
  public async ManuallyMarkGpsAtLocation(tracker: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/ManuallyMarkGpsAtLocation", null, { tracker: tracker });
  }
  public async GetMyObjects() : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetMyObjects", {  });
  }
  public async GetObjects(location: any, oneway: boolean, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetObjects", { location: location, oneway: oneway });
  }
  public async UpdateObject(objectId: any, title: string, localName: string, objectTypeId: number, availableOnline: boolean, nextInspectionDate: moment.Moment, showInUse4Free: boolean, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/UpdateObject", null, { objectId: objectId, title: title, localName: localName, objectTypeId: objectTypeId, availableOnline: availableOnline, nextInspectionDate: nextInspectionDate.toISOString(), showInUse4Free: showInUse4Free });
  }
  public async SaveObject(input: x.RentalObjectInfo, availableOnline: boolean, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/SaveObject", null, { input: input, availableOnline: availableOnline });
  }
  public async DeleteObject(objectId: any, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/DeleteObject", null, { objectId: objectId });
  }
  public async GetFleet() : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetFleet", {  });
  }
  public async GetGermanyRentalObjects(isWithinContext: boolean, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetGermanyRentalObjects", { isWithinContext: isWithinContext });
  }
  public async Enable(objectId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/Enable", { objectId: objectId });
  }
  public async PreEnableCheck(objectId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/PreEnableCheck", { objectId: objectId });
  }
  public async CreateServiceBookings(fromTime: any, toTime: any, objects: number[], ) : Promise<number> {
      return await this.api.post<number>("RentalObject/CreateServiceBookings", null, { fromTime: fromTime, toTime: toTime, objects: objects });
  }
  public async FindAvailableObjects(locationId: number, typeId: number, pickupTime: any, returnTime: any, inSameCategory: boolean, ignoreRentalId: number, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/FindAvailableObjects", { locationId: locationId, typeId: typeId, pickupTime: pickupTime, returnTime: returnTime, inSameCategory: inSameCategory, ignoreRentalId: ignoreRentalId });
  }
  public async FilterObjects(searchText: string, limit: number, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/FilterObjects", { searchText: searchText, limit: limit });
  }
  public async GetSecurityCheck(rentalObjectId: number, rentalId: number, isReturn: boolean, ) : Promise<string> {
      return await this.api.get<string>("RentalObject/GetSecurityCheck", { rentalObjectId: rentalObjectId, rentalId: rentalId, isReturn: isReturn });
  }
  public async GetSecurityCheckOnRentalObject(rentalObjectId: number, ) : Promise<any> {
      return await this.api.get<any>("RentalObject/GetSecurityCheckOnRentalObject", { rentalObjectId: rentalObjectId });
  }
  public async SetCsSecurityResult(type: number, rentalId: number, input: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/SetCsSecurityResult", { type: type, rentalId: rentalId, input: input });
  }
  public async SetAllCsSecurityResult(type: number, rentalObjectId: number, input: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/SetAllCsSecurityResult", { type: type, rentalObjectId: rentalObjectId, input: input });
  }
  public async GetAllActiveSecurityChecks(savedAt: moment.Moment, locationId: number, rentalLocationGroup: number, forServiceGuy: boolean, ) : Promise<x.DamageInfo[]> {
      return await this.api.get<x.DamageInfo[]>("RentalObject/GetAllActiveSecurityChecks", { savedAt: savedAt.toISOString(), locationId: locationId, rentalLocationGroup: rentalLocationGroup, forServiceGuy: forServiceGuy });
  }
  public async SaveSecurityCheck(rentalObjectId: number, rentalId: number, jsonData: string, isReturn: boolean, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/SaveSecurityCheck", { rentalObjectId: rentalObjectId, rentalId: rentalId, jsonData: jsonData, isReturn: isReturn });
  }
  public async StoreSafetyCheck(rentalObjectId: number, rentalId: number, isReturn: boolean, jsonData: string) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/StoreSafetyCheck", jsonData, { rentalObjectId: rentalObjectId, rentalId: rentalId, isReturn: isReturn });
  }
  public async StoreSafetyCheck1(securityCheckInfo: x.RentalObjectSecurityCheckInfo) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/StoreSafetyCheck", securityCheckInfo, {  });
  }
  public async GetRentalPhotos(bookingId: any, ) : Promise<x.T4File[]> {
      return await this.api.get<x.T4File[]>("RentalObject/GetRentalPhotos", { bookingId: bookingId });
  }
  public async RegisterLockAction(objectId: any, comment: string, handledTo: moment.Moment, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/RegisterLockAction", null, { objectId: objectId, comment: comment, handledTo: handledTo.toISOString() });
  }
  public async LookupLockId(mac: string, ) : Promise<string> {
      return await this.api.get<string>("RentalObject/LookupLockId", { mac: mac });
  }
  public async FilterLocks(searchText: string, limit: number, deviceType: number, ) : Promise<x.SmartLockInfo[]> {
      return await this.api.get<x.SmartLockInfo[]>("RentalObject/FilterLocks", { searchText: searchText, limit: limit, deviceType: deviceType });
  }
  public async FilterAssets(searchText: string, limit: number, deviceType: number, ) : Promise<x.AssetInfo[]> {
      return await this.api.get<x.AssetInfo[]>("RentalObject/FilterAssets", { searchText: searchText, limit: limit, deviceType: deviceType });
  }
  public async FilterAssetsInfo(searchText: string, limit: number, deviceType: number, iglooLock: boolean, ) : Promise<x.AssetInfo[]> {
      return await this.api.get<x.AssetInfo[]>("RentalObject/FilterAssetsInfo", { searchText: searchText, limit: limit, deviceType: deviceType, iglooLock: iglooLock });
  }
  public async GetObjectsWithMissingAssets() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetObjectsWithMissingAssets", {  });
  }
  public async CloseNote(noteId: number, ) : Promise<x.NoteInfo> {
      return await this.api.get<x.NoteInfo>("RentalObject/CloseNote", { noteId: noteId });
  }
  public async CreateNote(objectId: any, note: string, ) : Promise<x.NoteInfo> {
      return await this.api.get<x.NoteInfo>("RentalObject/CreateNote", { objectId: objectId, note: note });
  }
  public async GetOneWayFleet() : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetOneWayFleet", {  });
  }
  public async GetOneWayTypes() : Promise<x.ObjectTypeInfo[]> {
      return await this.api.get<x.ObjectTypeInfo[]>("RentalObject/GetOneWayTypes", {  });
  }
  public async GetUndoneTireChanges() : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("RentalObject/GetUndoneTireChanges", {  });
  }
  public async AddOneWayObject(title: string, alias: string, typeId: number, ) : Promise<any> {
      return await this.api.post<any>("RentalObject/AddOneWayObject", null, { title: title, alias: alias, typeId: typeId });
  }
  public async UpdateOneWayObject(obj: any, title: string, alias: string, typeId: number, ) : Promise<any> {
      return await this.api.post<any>("RentalObject/UpdateOneWayObject", null, { obj: obj, title: title, alias: alias, typeId: typeId });
  }
  public async RelieveOneWayObject(obj: any, ) : Promise<any> {
      return await this.api.post<any>("RentalObject/RelieveOneWayObject", null, { obj: obj });
  }
  public async ValidateRelocation(obj: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/ValidateRelocation", { obj: obj });
  }
  public async RelocateObject(obj: any, loc: any, isCorrection: boolean, manualBooking: boolean, ) : Promise<any> {
      return await this.api.post<any>("RentalObject/RelocateObject", null, { obj: obj, loc: loc, isCorrection: isCorrection, manualBooking: manualBooking });
  }
  public async RegisterTireChange(obj: any, loc: any, amount: number, debitLoc: any, debitAmount: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("RentalObject/RegisterTireChange", null, { obj: obj, loc: loc, amount: amount, debitLoc: debitLoc, debitAmount: debitAmount });
  }
  public async DeleteTireChange(tireChangeId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("RentalObject/DeleteTireChange", { tireChangeId: tireChangeId });
  }
  public async GetTireChangeData() : Promise<x.TireChangeInfo[]> {
      return await this.api.get<x.TireChangeInfo[]>("RentalObject/GetTireChangeData", {  });
  }
  public async KpiTrailerCount(from: moment.Moment, to: moment.Moment, ) : Promise<x.RentalKPI> {
      return await this.api.get<x.RentalKPI>("RentalObject/KpiTrailerCount", { from: from.toISOString(), to: to.toISOString() });
  }
  public async KpiDisabledTrailers(from: moment.Moment, ) : Promise<x.RentalKPI> {
      return await this.api.get<x.RentalKPI>("RentalObject/KpiDisabledTrailers", { from: from.toISOString() });
  }
  public async KpiAvailability(from: moment.Moment, to: moment.Moment, ) : Promise<x.RentalKPI> {
      return await this.api.get<x.RentalKPI>("RentalObject/KpiAvailability", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetOneWayFleetDashboard(startdate: moment.Moment, enddate: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("RentalObject/GetOneWayFleetDashboard", { startdate: startdate.toISOString(), enddate: enddate.toISOString() });
  }
  public async GetBluetoothLockStatus() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetBluetoothLockStatus", {  });
  }
  public async GetObjectsReport() : Promise<any> {
      return await this.api.get<any>("RentalObject/GetObjectsReport", {  });
  }
  public async TriggerNuwielStatus(deviceId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("RentalObject/TriggerNuwielStatus", { deviceId: deviceId });
  }
  public async GetLockInfo(lockId: string, ) : Promise<x.SmartLockInfo> {
      return await this.api.get<x.SmartLockInfo>("RentalObject/GetLockInfo", { lockId: lockId });
  }
}
@Injectable({providedIn: 'root' })
export class T4RentalService {
  constructor(private api: ApiService) {}
  public async StoreSurvey(survey: any) : Promise<any> {
      return await this.api.post<any>("Rental/StoreSurvey", survey, {  });
  }
  public async GetCustomerInfo(customerId: any, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Rental/GetCustomerInfo", { customerId: customerId });
  }
  public async FindCustomer(customerIdentification: string, type: any, isOneWay: boolean, ) : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Rental/FindCustomer", { customerIdentification: customerIdentification, type: type, isOneWay: isOneWay });
  }
  public async FindCustomerByUser() : Promise<x.CustomerInfo> {
      return await this.api.get<x.CustomerInfo>("Rental/FindCustomerByUser", {  });
  }
  public async SaveCustomer(input: x.CustomerInfo, ) : Promise<x.CustomerInfo> {
      return await this.api.post<x.CustomerInfo>("Rental/SaveCustomer", null, { input: input });
  }
  public async SaveCustomer1(input: x.CustomerInfo, isOneWay: boolean, ) : Promise<x.CustomerInfo> {
      return await this.api.post<x.CustomerInfo>("Rental/SaveCustomer", null, { input: input, isOneWay: isOneWay });
  }
  public async DeleteCustomerData(input: x.CustomerInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/DeleteCustomerData", null, { input: input });
  }
  public async EditCustomerInfo(input: x.CustomerInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/EditCustomerInfo", null, { input: input });
  }
  public async GetCustomers() : Promise<x.CustomerInfo[]> {
      return await this.api.get<x.CustomerInfo[]>("Rental/GetCustomers", {  });
  }
  public async GetCompanyCustomers() : Promise<x.CustomerInfo[]> {
      return await this.api.get<x.CustomerInfo[]>("Rental/GetCompanyCustomers", {  });
  }
  public async GetOneWayCustomers() : Promise<any> {
      return await this.api.get<any>("Rental/GetOneWayCustomers", {  });
  }
  public async GetFreeTimeSlots(locationId: number, categoryId: string, startTime: moment.Moment, endTime: moment.Moment, bookingId: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetFreeTimeSlots", { locationId: locationId, categoryId: categoryId, startTime: startTime.toISOString(), endTime: endTime.toISOString(), bookingId: bookingId });
  }
  public async GetAllTimeSlots(bookingId: number, query: x.FindSlotsQuery) : Promise<any> {
      return await this.api.post<any>("Rental/GetAllTimeSlots", query, { bookingId: bookingId });
  }
  public async GetFreeTimeSlotsOneWay(locationId: number, startTime: moment.Moment, endTime: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetFreeTimeSlotsOneWay", { locationId: locationId, startTime: startTime.toISOString(), endTime: endTime.toISOString() });
  }
  public async GetNextAvailableReturn(locationId: number, endTime: moment.Moment, maxLookaheadDays: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetNextAvailableReturn", { locationId: locationId, endTime: endTime.toISOString(), maxLookaheadDays: maxLookaheadDays });
  }
  public async FindAlternativeBookings(pickupTime: moment.Moment, returnTime: moment.Moment, typeCategoryId: number, objectTypeId: number, pickupLocationId: number, returnLocationId: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/FindAlternativeBookings", { pickupTime: pickupTime.toISOString(), returnTime: returnTime.toISOString(), typeCategoryId: typeCategoryId, objectTypeId: objectTypeId, pickupLocationId: pickupLocationId, returnLocationId: returnLocationId });
  }
  public async FindOneWayBookings(keywords: string, limit: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/FindOneWayBookings", { keywords: keywords, limit: limit });
  }
  public async ImportBooking(rentalId: number, ssn: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/ImportBooking", null, { rentalId: rentalId, ssn: ssn });
  }
  public async FindBookings(keywords: string, limit: number, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/FindBookings", { keywords: keywords, limit: limit });
  }
  public async IsAvailable(rentalId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/IsAvailable", { rentalId: rentalId });
  }
  public async FindBooking(bookingId: any, postalCode: string, ) : Promise<x.RentalInfo> {
      return await this.api.get<x.RentalInfo>("Rental/FindBooking", { bookingId: bookingId, postalCode: postalCode });
  }
  public async GetRentalInfo(bookingId: any, ) : Promise<x.RentalInfo> {
      return await this.api.get<x.RentalInfo>("Rental/GetRentalInfo", { bookingId: bookingId });
  }
  public async GetRentalSummary(bookingId: any, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetRentalSummary", { bookingId: bookingId });
  }
  public async GetRentalMainGroup() : Promise<string> {
      return await this.api.get<string>("Rental/GetRentalMainGroup", {  });
  }
  public async GetReceiptUri(rentalId: any, type: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/GetReceiptUri", { rentalId: rentalId, type: type });
  }
  public async CreateReceipt(rentalId: any, type: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/CreateReceipt", { rentalId: rentalId, type: type });
  }
  public async GetCustomerRentals(customerId: number, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetCustomerRentals", { customerId: customerId });
  }
  public async GetCustomerInvoiceRentals(customerId: number, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetCustomerInvoiceRentals", { customerId: customerId });
  }
  public async ValidateCustomerNumber(customerNumber: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ValidateCustomerNumber", { customerNumber: customerNumber });
  }
  public async ValidateInvoiceCode(rentalId: number, invoiceCode: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ValidateInvoiceCode", { rentalId: rentalId, invoiceCode: invoiceCode });
  }
  public async GetNearbyOneWayAvailability(referenceLocationId: number, referenceTime: moment.Moment, showEmpty: boolean, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetNearbyOneWayAvailability", { referenceLocationId: referenceLocationId, referenceTime: referenceTime.toISOString(), showEmpty: showEmpty });
  }
  public async GetRentals(startTime: any, endTime: any, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetRentals", { startTime: startTime, endTime: endTime });
  }
  public async GetDeletedRentals(startTime: any, endTime: any, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetDeletedRentals", { startTime: startTime, endTime: endTime });
  }
  public async GetActiveRentals() : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetActiveRentals", {  });
  }
  public async GetUpcomingRentals() : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetUpcomingRentals", {  });
  }
  public async GetMyBookings() : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetMyBookings", {  });
  }
  public async FindBookings1(customerIdentification: string, zipcode: string, ) : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/FindBookings", { customerIdentification: customerIdentification, zipcode: zipcode });
  }
  public async GetMyActiveAndFutureBookings() : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetMyActiveAndFutureBookings", {  });
  }
  public async GetMyCompletedAndDeletedBookings() : Promise<x.RentalInfo[]> {
      return await this.api.get<x.RentalInfo[]>("Rental/GetMyCompletedAndDeletedBookings", {  });
  }
  public async RentalEvent(rentalId: any, type: any, message: string, ) : Promise<any> {
      return await this.api.post<any>("Rental/RentalEvent", null, { rentalId: rentalId, type: type, message: message });
  }
  public async GetEvents(rental: any, ) : Promise<x.EntityEventInfo[]> {
      return await this.api.get<x.EntityEventInfo[]>("Rental/GetEvents", { rental: rental });
  }
  public async GetCSEvents(rentalId: any, ) : Promise<x.EntityEventInfo[]> {
      return await this.api.get<x.EntityEventInfo[]>("Rental/GetCSEvents", { rentalId: rentalId });
  }
  public async FindDelayedBooking(objectId: any, ) : Promise<number> {
      return await this.api.get<number>("Rental/FindDelayedBooking", { objectId: objectId });
  }
  public async GetCosts(booking: any, ) : Promise<x.CostInfo[]> {
      return await this.api.get<x.CostInfo[]>("Rental/GetCosts", { booking: booking });
  }
  public async RegisterManualInvoice(requestId: number, invoiceRef: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/RegisterManualInvoice", { requestId: requestId, invoiceRef: invoiceRef });
  }
  public async GetCostList(from: moment.Moment, to: moment.Moment, ) : Promise<x.CostInfo[]> {
      return await this.api.get<x.CostInfo[]>("Rental/GetCostList", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetPayments(booking: any, ) : Promise<x.PaymentInfo[]> {
      return await this.api.get<x.PaymentInfo[]>("Rental/GetPayments", { booking: booking });
  }
  public async GetPaymentRequests(booking: any, ) : Promise<x.PaymentRequestInfo[]> {
      return await this.api.get<x.PaymentRequestInfo[]>("Rental/GetPaymentRequests", { booking: booking });
  }
  public async GetFiltedPaymentRequestsList(paymentRequestStatus: any, ) : Promise<x.PaymentRequestInfo[]> {
      return await this.api.get<x.PaymentRequestInfo[]>("Rental/GetFiltedPaymentRequestsList", { paymentRequestStatus: paymentRequestStatus });
  }
  public async GetPaymentRequestsList(from: moment.Moment, to: moment.Moment, ) : Promise<x.PaymentRequestInfo[]> {
      return await this.api.get<x.PaymentRequestInfo[]>("Rental/GetPaymentRequestsList", { from: from.toISOString(), to: to.toISOString() });
  }
  public async SLExtend(rentalId: number, hours: number, ) : Promise<x.ProlongRentalResult> {
      return await this.api.get<x.ProlongRentalResult>("Rental/SLExtend", { rentalId: rentalId, hours: hours });
  }
  public async GetRentalsWithSpareParts(rentalObjectId: any, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetRentalsWithSpareParts", { rentalObjectId: rentalObjectId });
  }
  public async CheckNextBookingForExtend(objectId: any, rentalId: any, ) : Promise<moment.Moment> {
      return await this.api.get<moment.Moment>("Rental/CheckNextBookingForExtend", { objectId: objectId, rentalId: rentalId });
  }
  public async GetExtendedCost(rentalid: any, extendTo: moment.Moment, ) : Promise<number> {
      return await this.api.get<number>("Rental/GetExtendedCost", { rentalid: rentalid, extendTo: extendTo.toISOString() });
  }
  public async ExtendToDate(rentalId: any, extendTo: moment.Moment, ) : Promise<x.ProlongRentalResult> {
      return await this.api.get<x.ProlongRentalResult>("Rental/ExtendToDate", { rentalId: rentalId, extendTo: extendTo.toISOString() });
  }
  public async SLCanExtend(rentalId: number, hours: number, moveCollidingRentals: boolean, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/SLCanExtend", { rentalId: rentalId, hours: hours, moveCollidingRentals: moveCollidingRentals });
  }
  public async SLGetExtendOptions(bookingCode: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/SLGetExtendOptions", { bookingCode: bookingCode });
  }
  public async SetRentalEvent(rentalId: any, content: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/SetRentalEvent", { rentalId: rentalId, content: content });
  }
  public async LogEvent(rentalId: any, content: string) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/LogEvent", content, { rentalId: rentalId });
  }
  public async SaveLockActivity(lockId: string, batteryLevel: number, type: any, version: string, reason: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/SaveLockActivity", { lockId: lockId, batteryLevel: batteryLevel, type: type, version: version, reason: reason });
  }
  public async UpdatedUnlockNoke(rentalId: any, macAddress: string, sessionString: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/UpdatedUnlockNoke", { rentalId: rentalId, macAddress: macAddress, sessionString: sessionString });
  }
  public async UpdatedUnlockNokeByAdmin(macAddress: string, sessionString: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/UpdatedUnlockNokeByAdmin", { macAddress: macAddress, sessionString: sessionString });
  }
  public async UpdatedUnshackleNoke(macAddress: string, sessionString: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/UpdatedUnshackleNoke", { macAddress: macAddress, sessionString: sessionString });
  }
  public async UpdatedLockInfoNoke(macs: any, ) : Promise<any> {
      return await this.api.get<any>("Rental/UpdatedLockInfoNoke", { macs: macs });
  }
  public async UpdatedFirmwareUpdateNoke(macAddress: string, sessionString: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/UpdatedFirmwareUpdateNoke", { macAddress: macAddress, sessionString: sessionString });
  }
  public async UnlockNoke(rentalId: any, macAddress: string, sessionString: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/UnlockNoke", { rentalId: rentalId, macAddress: macAddress, sessionString: sessionString });
  }
  public async UnlockNokeByAdmin(macAddress: string, sessionString: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/UnlockNokeByAdmin", { macAddress: macAddress, sessionString: sessionString });
  }
  public async LockInfoNoke(macAddress: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/LockInfoNoke", { macAddress: macAddress });
  }
  public async UnshackleNoke(macAddress: string, sessionString: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/UnshackleNoke", { macAddress: macAddress, sessionString: sessionString });
  }
  public async FirmwareUpdateNoke(macAddress: string, sessionString: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/FirmwareUpdateNoke", { macAddress: macAddress, sessionString: sessionString });
  }
  public async ActivityNoke(macAddress: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/ActivityNoke", { macAddress: macAddress });
  }
  public async IssueOfflineKeys(macs: string[], ) : Promise<any> {
      return await this.api.post<any>("Rental/IssueOfflineKeys", null, { macs: macs });
  }
  public async IssueQCNoke(macAddress: string, code: string, uses: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/IssueQCNoke", { macAddress: macAddress, code: code, uses: uses });
  }
  public async RevokeQCNoke(macAddress: string, code: string, uses: number, ) : Promise<any> {
      return await this.api.get<any>("Rental/RevokeQCNoke", { macAddress: macAddress, code: code, uses: uses });
  }
  public async ValidateLockId(lockId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ValidateLockId", { lockId: lockId });
  }
  public async GetRentalObjects() : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("Rental/GetRentalObjects", {  });
  }
  public async GetRentalObjectsForLocation(locationId: any, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("Rental/GetRentalObjectsForLocation", { locationId: locationId });
  }
  public async LinkLock(lockId: string, objectId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/LinkLock", { lockId: lockId, objectId: objectId });
  }
  public async LinkTracker(objectId: number, lockId: string, isConfirm: boolean, ) : Promise<number> {
      return await this.api.get<number>("Rental/LinkTracker", { objectId: objectId, lockId: lockId, isConfirm: isConfirm });
  }
  public async LinkDevice(objectId: number, lockId: string, lockType: number, isConfirm: boolean, ) : Promise<number> {
      return await this.api.get<number>("Rental/LinkDevice", { objectId: objectId, lockId: lockId, lockType: lockType, isConfirm: isConfirm });
  }
  public async LinkDeviceInfo(objectId: number, lockId: string, lockType: number, isConfirm: boolean, iglooLock: boolean, ) : Promise<number> {
      return await this.api.get<number>("Rental/LinkDeviceInfo", { objectId: objectId, lockId: lockId, lockType: lockType, isConfirm: isConfirm, iglooLock: iglooLock });
  }
  public async LinkDeviceToUpcomingTrailerWithLogging(objectTitle: string, lockId: string, lockType: number, isConfirm: boolean, modelNo: string, tagId: string, invoiceAccount: string, logMessage: string, iglooLock: boolean, ) : Promise<number> {
      return await this.api.get<number>("Rental/LinkDeviceToUpcomingTrailerWithLogging", { objectTitle: objectTitle, lockId: lockId, lockType: lockType, isConfirm: isConfirm, modelNo: modelNo, tagId: tagId, invoiceAccount: invoiceAccount, logMessage: logMessage, iglooLock: iglooLock });
  }
  public async LinkDeviceToUpcomingTrailer(objectTitle: string, lockId: string, lockType: number, isConfirm: boolean, modelNo: string, tagId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/LinkDeviceToUpcomingTrailer", { objectTitle: objectTitle, lockId: lockId, lockType: lockType, isConfirm: isConfirm, modelNo: modelNo, tagId: tagId });
  }
  public async LinkDeviceWithInvoiceAccount(objectTitle: string, lockId: string, lockType: number, isConfirm: boolean, modelNo: string, tagId: string, invoiceAccount: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/LinkDeviceWithInvoiceAccount", { objectTitle: objectTitle, lockId: lockId, lockType: lockType, isConfirm: isConfirm, modelNo: modelNo, tagId: tagId, invoiceAccount: invoiceAccount });
  }
  public async DisconnectPendingDevice(deviceId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/DisconnectPendingDevice", { deviceId: deviceId });
  }
  public async AddNfcLock(objectTitle: string, ObjectId: number, TagId: string, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/AddNfcLock", null, { objectTitle: objectTitle, ObjectId: ObjectId, TagId: TagId });
  }
  public async AddNfcLockWithLogging(objectTitle: string, ObjectId: number, TagId: string, logMessage: string, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/AddNfcLockWithLogging", null, { objectTitle: objectTitle, ObjectId: ObjectId, TagId: TagId, logMessage: logMessage });
  }
  public async GetRecalledTrailers(locationId: any, ) : Promise<x.RentalObjectInfo[]> {
      return await this.api.get<x.RentalObjectInfo[]>("Rental/GetRecalledTrailers", { locationId: locationId });
  }
  public async SetRecalledAction(objectId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/SetRecalledAction", null, { objectId: objectId });
  }
  public async ConnectLock(objectId: number, lockId: string, lockType: number, isConfirm: boolean, ) : Promise<x.ConnectLockToObjectInfo> {
      return await this.api.get<x.ConnectLockToObjectInfo>("Rental/ConnectLock", { objectId: objectId, lockId: lockId, lockType: lockType, isConfirm: isConfirm });
  }
  public async DisconnectLock(objectId: number, lockId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/DisconnectLock", { objectId: objectId, lockId: lockId });
  }
  public async ChangeExistingLock(lockId: string, objectId: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ChangeExistingLock", { lockId: lockId, objectId: objectId });
  }
  public async ChangeExistingLock1(lockId: string, objectId: number, lockType: number, ) : Promise<number> {
      return await this.api.get<number>("Rental/ChangeExistingLock", { lockId: lockId, objectId: objectId, lockType: lockType });
  }
  public async UpdateLockStatus(macAddress: string, battery: number, version: string, autoDisable: boolean, condition: number, holder: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/UpdateLockStatus", { macAddress: macAddress, battery: battery, version: version, autoDisable: autoDisable, condition: condition, holder: holder });
  }
  public async RequestPayment(rentalId: any, description: string, ) : Promise<x.PaymentRequestInfo> {
      return await this.api.post<x.PaymentRequestInfo>("Rental/RequestPayment", null, { rentalId: rentalId, description: description });
  }
  public async GetLockInventoryAsync(username: string, objectId: number, rentalLocationId: number, lockId: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetLockInventoryAsync", { username: username, objectId: objectId, rentalLocationId: rentalLocationId, lockId: lockId });
  }
  public async ReversBooking(bookingId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ReversBooking", { bookingId: bookingId });
  }
  public async GetMyLockInventory() : Promise<x.AssetsAndHolder[]> {
      return await this.api.get<x.AssetsAndHolder[]>("Rental/GetMyLockInventory", {  });
  }
  public async ChangeLockInInventory(lockId: string, condition: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ChangeLockInInventory", { lockId: lockId, condition: condition });
  }
  public async FilterAssets(searchText: string, limit: number, ) : Promise<x.AssetInfo[]> {
      return await this.api.get<x.AssetInfo[]>("Rental/FilterAssets", { searchText: searchText, limit: limit });
  }
  public async UploadNoke(rentalId: any, macAddress: string, sessionString: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/UploadNoke", { rentalId: rentalId, macAddress: macAddress, sessionString: sessionString });
  }
  public async BeginDigitalSigning(rental: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/BeginDigitalSigning", { rental: rental });
  }
  public async CancelPaymentRequest(requestId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/CancelPaymentRequest", null, { requestId: requestId });
  }
  public async ValidateSignature(rental: any, token: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ValidateSignature", { rental: rental, token: token });
  }
  public async UserExists(number: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/UserExists", { number: number });
  }
  public async ValidateUser(userName: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/ValidateUser", { userName: userName });
  }
  public async BeginDigitalUserSigning(number: string, newNumber: string, demo: boolean, ) : Promise<x.UserSignInResult> {
      return await this.api.get<x.UserSignInResult>("Rental/BeginDigitalUserSigning", { number: number, newNumber: newNumber, demo: demo });
  }
  public async BeginDigitalUserSigning1(request: x.AppUserSignInRequest) : Promise<x.UserSignInResult> {
      return await this.api.post<x.UserSignInResult>("Rental/BeginDigitalUserSigning", request, {  });
  }
  public async GetMapLocations() : Promise<any> {
      return await this.api.get<any>("Rental/GetMapLocations", {  });
  }
  public async ValidateUserSignature(number: string, email: string, token: string, newNumber: string, demo: boolean, countryCode: string, ) : Promise<x.UserValidationResult> {
      return await this.api.get<x.UserValidationResult>("Rental/ValidateUserSignature", { number: number, email: email, token: token, newNumber: newNumber, demo: demo, countryCode: countryCode });
  }
  public async RegisterUserDevice(request: x.RegisterUserDeviceRequest) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/RegisterUserDevice", request, {  });
  }
  public async CreateBooking(pickupTime: any, returnTime: any, pickupLocation: number, returnLocation: number, typeId: number, discountId: string, notes: string, addons: number[], specificObjectId: number, webBooking: boolean, bookingLat: number, bookingLng: number, rentalMetadata: string, travelRange: any, useCurrentContext: boolean, customer: x.CustomerInfo) : Promise<x.BookingValidation> {
      return await this.api.post<x.BookingValidation>("Rental/CreateBooking", customer, { pickupTime: pickupTime, returnTime: returnTime, pickupLocation: pickupLocation, returnLocation: returnLocation, typeId: typeId, discountId: discountId, notes: notes, addons: addons, specificObjectId: specificObjectId, webBooking: webBooking, bookingLat: bookingLat, bookingLng: bookingLng, rentalMetadata: rentalMetadata, travelRange: travelRange, useCurrentContext: useCurrentContext });
  }
  public async CreateBooking1(pickupTime: any, returnTime: any, pickupLocation: number, returnLocation: number, obj: any, typeId: number, customer: any, discountId: string, notes: string, isOneWay: boolean, webBooking: boolean, bookingLat: number, bookingLng: number, rentalMetaData: string, travelRange: any, useCurrentContext: boolean, ) : Promise<x.BookingValidation> {
      return await this.api.post<x.BookingValidation>("Rental/CreateBooking", null, { pickupTime: pickupTime, returnTime: returnTime, pickupLocation: pickupLocation, returnLocation: returnLocation, obj: obj, typeId: typeId, customer: customer, discountId: discountId, notes: notes, isOneWay: isOneWay, webBooking: webBooking, bookingLat: bookingLat, bookingLng: bookingLng, rentalMetaData: rentalMetaData, travelRange: travelRange, useCurrentContext: useCurrentContext });
  }
  public async CreateBookingModel(modelObject: x.CreateBookingModel, ) : Promise<x.BookingValidation> {
      return await this.api.post<x.BookingValidation>("Rental/CreateBookingModel", null, { modelObject: modelObject });
  }
  public async ChangeBooking(rentalId: number, pickupTime: any, returnTime: any, pickupLocation: any, returnLocation: any, typeId: number, discountId: string, addons: number[], specificObjectId: number, webBooking: boolean, bookingLat: number, bookingLng: number, rentalMetadata: string, travelRange: any, ) : Promise<x.BookingValidation> {
      return await this.api.put<x.BookingValidation>("Rental/ChangeBooking", null, { rentalId: rentalId, pickupTime: pickupTime, returnTime: returnTime, pickupLocation: pickupLocation, returnLocation: returnLocation, typeId: typeId, discountId: discountId, addons: addons, specificObjectId: specificObjectId, webBooking: webBooking, bookingLat: bookingLat, bookingLng: bookingLng, rentalMetadata: rentalMetadata, travelRange: travelRange });
  }
  public async GetDeviceTechStack(rentalId: any, ) : Promise<string> {
      return await this.api.get<string>("Rental/GetDeviceTechStack", { rentalId: rentalId });
  }
  public async FixFailedReturn(rentalId: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/FixFailedReturn", { rentalId: rentalId });
  }
  public async GetPickupTrailerPoint(rentalId: any, ) : Promise<string> {
      return await this.api.get<string>("Rental/GetPickupTrailerPoint", { rentalId: rentalId });
  }
  public async SwapTrailer(rentalId: any, ) : Promise<x.BookingValidation> {
      return await this.api.post<x.BookingValidation>("Rental/SwapTrailer", null, { rentalId: rentalId });
  }
  public async SwapTrailer2(rentalId: any, ) : Promise<x.SwapTrailerResults> {
      return await this.api.post<x.SwapTrailerResults>("Rental/SwapTrailer2", null, { rentalId: rentalId });
  }
  public async AutoStartFromBot(rentalId: any, regNo: string, ) : Promise<number> {
      return await this.api.post<number>("Rental/AutoStartFromBot", null, { rentalId: rentalId, regNo: regNo });
  }
  public async ChangeTrailer(rentalId: any, trailerId: any, additionalInfo: string, ) : Promise<x.BookingValidation> {
      return await this.api.post<x.BookingValidation>("Rental/ChangeTrailer", null, { rentalId: rentalId, trailerId: trailerId, additionalInfo: additionalInfo });
  }
  public async UpdateBooking(rentalId: any, pickupTime: any, returnTime: any, pickupLocation: any, returnLocation: any, obj: any, typeId: number, discountId: string, addons: number[], specificObjectId: number, webBooking: boolean, bookingLat: number, bookingLng: number, rentalMetadata: string, ) : Promise<x.BookingValidation> {
      return await this.api.put<x.BookingValidation>("Rental/UpdateBooking", null, { rentalId: rentalId, pickupTime: pickupTime, returnTime: returnTime, pickupLocation: pickupLocation, returnLocation: returnLocation, obj: obj, typeId: typeId, discountId: discountId, addons: addons, specificObjectId: specificObjectId, webBooking: webBooking, bookingLat: bookingLat, bookingLng: bookingLng, rentalMetadata: rentalMetadata });
  }
  public async SetCustomer(rentalId: any, customer: any, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/SetCustomer", null, { rentalId: rentalId, customer: customer });
  }
  public async SetForeignTravel(rentalId: any, code: string, country: string, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/SetForeignTravel", null, { rentalId: rentalId, code: code, country: country });
  }
  public async SetAddons(rentalId: any, products: number[], useCurrentContext: boolean, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/SetAddons", null, { rentalId: rentalId, products: products, useCurrentContext: useCurrentContext });
  }
  public async SetDiscount(rentalId: any, discountCode: string, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/SetDiscount", null, { rentalId: rentalId, discountCode: discountCode });
  }
  public async SetNotes(rentalId: any, notes: string, ) : Promise<boolean> {
      return await this.api.put<boolean>("Rental/SetNotes", null, { rentalId: rentalId, notes: notes });
  }
  public async Confirm(booking: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/Confirm", { booking: booking });
  }
  public async Flag(booking: any, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/Flag", { booking: booking });
  }
  public async resendEmailConfirmation(rentalID: any, ) : Promise<any> {
      return await this.api.get<any>("Rental/resendEmailConfirmation", { rentalID: rentalID });
  }
  public async GetDibsTicketFromCustomer(rentalId: number, customerId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/GetDibsTicketFromCustomer", null, { rentalId: rentalId, customerId: customerId });
  }
  public async SaveDibsTicketToCustomer(rentalId: number, customerId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/SaveDibsTicketToCustomer", null, { rentalId: rentalId, customerId: customerId });
  }
  public async RemoveDibsTicket(rentalId: number, customerId: number, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/RemoveDibsTicket", null, { rentalId: rentalId, customerId: customerId });
  }
  public async Disclose(pickupModel: x.PickupModel) : Promise<x.BookingResult> {
      return await this.api.post<x.BookingResult>("Rental/Disclose", pickupModel, {  });
  }
  public async Disclose1(rentalId: number, bypassCardPayment: boolean, predisclose: boolean, ) : Promise<x.PickupResultCode> {
      return await this.api.post<x.PickupResultCode>("Rental/Disclose", null, { rentalId: rentalId, bypassCardPayment: bypassCardPayment, predisclose: predisclose });
  }
  public async RecreatePickupContract(id: any, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/RecreatePickupContract", null, { id: id });
  }
  public async ValidateForReturn(rentalId: any, returnTime: any, returnLocation: any, ) : Promise<x.ReturnValidation> {
      return await this.api.post<x.ReturnValidation>("Rental/ValidateForReturn", null, { rentalId: rentalId, returnTime: returnTime, returnLocation: returnLocation });
  }
  public async Return(returnModel: x.ReturnModel) : Promise<x.BookingResult> {
      return await this.api.post<x.BookingResult>("Rental/Return", returnModel, {  });
  }
  public async Return1(rentalId: any, returnTime: any, returnLocation: any, receiptAction: any, addons: number[], extraReason: string, bypassCardPayment: boolean, ) : Promise<x.ReturnResultCode> {
      return await this.api.post<x.ReturnResultCode>("Rental/Return", null, { rentalId: rentalId, returnTime: returnTime, returnLocation: returnLocation, receiptAction: receiptAction, addons: addons, extraReason: extraReason, bypassCardPayment: bypassCardPayment });
  }
  public async Cancel(booking: any, comment: string, ) : Promise<any> {
      return await this.api.delete<any>("Rental/Cancel", { booking: booking, comment: comment });
  }
  public async CancelWithComment(rentalId: any, postalCode: string, message: string, ) : Promise<any> {
      return await this.api.delete<any>("Rental/CancelWithComment", { rentalId: rentalId, postalCode: postalCode, message: message });
  }
  public async RefundPayment(paymentId: number, amount: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/RefundPayment", { paymentId: paymentId, amount: amount });
  }
  public async GetPaymentURI(rentalId: number, ) : Promise<string> {
      return await this.api.get<string>("Rental/GetPaymentURI", { rentalId: rentalId });
  }
  public async GetDiscountReasons(isOneWay: boolean, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetDiscountReasons", { isOneWay: isOneWay });
  }
  public async GetTurnover(startTime: any, endTime: any, ) : Promise<x.LocationKpi> {
      return await this.api.get<x.LocationKpi>("Rental/GetTurnover", { startTime: startTime, endTime: endTime });
  }
  public async GetSales(lowLimit: moment.Moment, highLimit: moment.Moment, ) : Promise<x.DateValue[]> {
      return await this.api.get<x.DateValue[]>("Rental/GetSales", { lowLimit: lowLimit.toISOString(), highLimit: highLimit.toISOString() });
  }
  public async GetDailySales(from: moment.Moment, to: moment.Moment, ) : Promise<x.DailySalesItem[]> {
      return await this.api.get<x.DailySalesItem[]>("Rental/GetDailySales", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetRentalReport(from: moment.Moment, to: moment.Moment, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetRentalReport", { from: from.toISOString(), to: to.toISOString() });
  }
  public async StorePickupPhoto(rentalId: number, angle: any, data: string) : Promise<string> {
      return await this.api.post<string>("Rental/StorePickupPhoto", data, { rentalId: rentalId, angle: angle });
  }
  public async StoreReturnPhoto(rentalId: number, angle: any, data: string) : Promise<string> {
      return await this.api.post<string>("Rental/StoreReturnPhoto", data, { rentalId: rentalId, angle: angle });
  }
  public async StoreFaultReportPhoto(rentalId: number, angle: any, data: string) : Promise<string> {
      return await this.api.post<string>("Rental/StoreFaultReportPhoto", data, { rentalId: rentalId, angle: angle });
  }
  public async CreatePhotoAngle(angle: x.PhotoAngleInfo, ) : Promise<number> {
      return await this.api.post<number>("Rental/CreatePhotoAngle", null, { angle: angle });
  }
  public async UpdatePhotoAngle(updatedAngle: x.PhotoAngleInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/UpdatePhotoAngle", null, { updatedAngle: updatedAngle });
  }
  public async DeletePhotoAngle(angleId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Rental/DeletePhotoAngle", { angleId: angleId });
  }
  public async GetAllPhotoAngles() : Promise<x.PhotoAngleInfo[]> {
      return await this.api.get<x.PhotoAngleInfo[]>("Rental/GetAllPhotoAngles", {  });
  }
  public async GetPhotoAnglesForType(typeClassId: number, ) : Promise<x.PhotoAngleInfo[]> {
      return await this.api.get<x.PhotoAngleInfo[]>("Rental/GetPhotoAnglesForType", { typeClassId: typeClassId });
  }
  public async GetPhotoAnglesInfo(bookingId: any, ) : Promise<x.PhotoAngleInfo[]> {
      return await this.api.get<x.PhotoAngleInfo[]>("Rental/GetPhotoAnglesInfo", { bookingId: bookingId });
  }
  public async GetSafetyCheckQuestionsInfo(bookingId: any, ) : Promise<x.SafetyCheckQuestionInfo[]> {
      return await this.api.get<x.SafetyCheckQuestionInfo[]>("Rental/GetSafetyCheckQuestionsInfo", { bookingId: bookingId });
  }
  public async GetSafetyCheckQuestionsForType(typeClassId: number, ) : Promise<x.SafetyCheckQuestionInfo[]> {
      return await this.api.get<x.SafetyCheckQuestionInfo[]>("Rental/GetSafetyCheckQuestionsForType", { typeClassId: typeClassId });
  }
  public async MoveBookingTime(rentalId: any, reason: string, ) : Promise<any> {
      return await this.api.get<any>("Rental/MoveBookingTime", { rentalId: rentalId, reason: reason });
  }
  public async AddCategoryPhotoAngle(angleId: number, customerCategoryId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/AddCategoryPhotoAngle", null, { angleId: angleId, customerCategoryId: customerCategoryId });
  }
  public async RemoveCategoryPhotoAngleMapping(angleId: number, customerCategoryId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Rental/RemoveCategoryPhotoAngleMapping", null, { angleId: angleId, customerCategoryId: customerCategoryId });
  }
  public async UnlockIglooLock(rentalId: any, payload: string, timezone: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/UnlockIglooLock", { rentalId: rentalId, payload: payload, timezone: timezone });
  }
  public async GetTimeZoneConfiguration(timezoneId: string, ) : Promise<string> {
      return await this.api.get<string>("Rental/GetTimeZoneConfiguration", { timezoneId: timezoneId });
  }
  public async GetPairedLocks(rentalId: any, ) : Promise<any> {
      return await this.api.get<any>("Rental/GetPairedLocks", { rentalId: rentalId });
  }
  public async UnlockIglooLockGuest(rentalId: any, lockid: string, startDate: string, endDate: string, permissions: any, ) : Promise<string> {
      return await this.api.get<string>("Rental/UnlockIglooLockGuest", { rentalId: rentalId, lockid: lockid, startDate: startDate, endDate: endDate, permissions: permissions });
  }
  public async UnlockIglooLockOTP(rentalId: any, lockid: string, timezoneId: string, startDate: string, timeDuration: number, ) : Promise<string> {
      return await this.api.get<string>("Rental/UnlockIglooLockOTP", { rentalId: rentalId, lockid: lockid, timezoneId: timezoneId, startDate: startDate, timeDuration: timeDuration });
  }
  public async UpdateIglooLockStatus(lockId: string, battery: number, version: string, autoDisable: boolean, condition: number, holder: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/UpdateIglooLockStatus", { lockId: lockId, battery: battery, version: version, autoDisable: autoDisable, condition: condition, holder: holder });
  }
  public async SaveIglooLockActivity(lockId: string, type: any, version: string, batteryLevel: number, reason: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Rental/SaveIglooLockActivity", { lockId: lockId, type: type, version: version, batteryLevel: batteryLevel, reason: reason });
  }
  public async GetPickupReceiptUri(bookingId: any, ) : Promise<x.RentalReceipt> {
      return await this.api.get<x.RentalReceipt>("Rental/GetPickupReceiptUri", { bookingId: bookingId });
  }
}
@Injectable({providedIn: 'root' })
export class T4ServiceBase {
  constructor(private api: ApiService) {}
}
@Injectable({providedIn: 'root' })
export class T4SettingsService {
  constructor(private api: ApiService) {}
  public async SetTranslation(key: string, newValue: string, language: string, comment: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/SetTranslation", { key: key, newValue: newValue, language: language, comment: comment });
  }
  public async TrackTranslations(language: string, keys: any) : Promise<any> {
      return await this.api.post<any>("Settings/TrackTranslations", keys, { language: language });
  }
  public async SaveAllLanguageTranslationsForKey(defaultlanguage: string, translationFields: x.TranslationField[]) : Promise<boolean> {
      return await this.api.post<boolean>("Settings/SaveAllLanguageTranslationsForKey", translationFields, { defaultlanguage: defaultlanguage });
  }
  public async GetAllLanguageTranslationsForKey(translationKey: string, ) : Promise<any> {
      return await this.api.get<any>("Settings/GetAllLanguageTranslationsForKey", { translationKey: translationKey });
  }
  public async GetAllTranslations() : Promise<any> {
      return await this.api.get<any>("Settings/GetAllTranslations", {  });
  }
  public async SaveAllLanguageTranslations(updatedTranslations: x.TranslationInfo[]) : Promise<boolean> {
      return await this.api.post<boolean>("Settings/SaveAllLanguageTranslations", updatedTranslations, {  });
  }
  public async DeleteAllLanguageTranslationsForKey(translationKey: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Settings/DeleteAllLanguageTranslationsForKey", { translationKey: translationKey });
  }
  public async GetSettingsPages() : Promise<any> {
      return await this.api.get<any>("Settings/GetSettingsPages", {  });
  }
  public async SaveLocationSetting(setting: x.T4Setting) : Promise<x.T4Setting> {
      return await this.api.post<x.T4Setting>("Settings/SaveLocationSetting", setting, {  });
  }
  public async GetSetupLocations() : Promise<any> {
      return await this.api.get<any>("Settings/GetSetupLocations", {  });
  }
  public async UpdateSetupLocations(contextId: string, value: boolean, operation: number, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/UpdateSetupLocations", { contextId: contextId, value: value, operation: operation });
  }
  public async GetCustomerDefinitionGuid(bookingContext: string, ) : Promise<x.ClientSettings> {
      return await this.api.get<x.ClientSettings>("Settings/GetCustomerDefinitionGuid", { bookingContext: bookingContext });
  }
  public async GetCustomerDefinition(rentalId: any, ) : Promise<x.ClientSettings> {
      return await this.api.get<x.ClientSettings>("Settings/GetCustomerDefinition", { rentalId: rentalId });
  }
  public async GetTrailerPoint() : Promise<x.TrailerPointInfo> {
      return await this.api.get<x.TrailerPointInfo>("Settings/GetTrailerPoint", {  });
  }
  public async UpdateTrailerPoint(radius: number, lat: number, lng: number, ) : Promise<any> {
      return await this.api.post<any>("Settings/UpdateTrailerPoint", null, { radius: radius, lat: lat, lng: lng });
  }
  public async UpdateLocationTrailerPoint(locationId: number, radius: number, lat: number, lng: number, ) : Promise<any> {
      return await this.api.post<any>("Settings/UpdateLocationTrailerPoint", null, { locationId: locationId, radius: radius, lat: lat, lng: lng });
  }
  public async GetAgreementText() : Promise<string> {
      return await this.api.get<string>("Settings/GetAgreementText", {  });
  }
  public async ClearServerCache() : Promise<boolean> {
      return await this.api.get<boolean>("Settings/ClearServerCache", {  });
  }
  public async ChangeLanguage(language: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/ChangeLanguage", { language: language });
  }
  public async getUserDetails(userId: string, ) : Promise<any> {
      return await this.api.get<any>("Settings/getUserDetails", { userId: userId });
  }
  public async CorrectUserContext(userContext: string, parentId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/CorrectUserContext", { userContext: userContext, parentId: parentId });
  }
  public async needUserVerification() : Promise<boolean> {
      return await this.api.get<boolean>("Settings/needUserVerification", {  });
  }
  public async GetPricelists() : Promise<x.T4PricelistInfo[]> {
      return await this.api.get<x.T4PricelistInfo[]>("Settings/GetPricelists", {  });
  }
  public async GetAllActivePricelists() : Promise<x.T4PricelistInfo[]> {
      return await this.api.get<x.T4PricelistInfo[]>("Settings/GetAllActivePricelists", {  });
  }
  public async GetChildPricelists() : Promise<x.T4PricelistInfo[]> {
      return await this.api.get<x.T4PricelistInfo[]>("Settings/GetChildPricelists", {  });
  }
  public async GetActiveStationPricelists() : Promise<x.T4PricelistInfo[]> {
      return await this.api.get<x.T4PricelistInfo[]>("Settings/GetActiveStationPricelists", {  });
  }
  public async GetChildGroups() : Promise<x.LocationGroupInfo[]> {
      return await this.api.get<x.LocationGroupInfo[]>("Settings/GetChildGroups", {  });
  }
  public async GetChildLocations() : Promise<x.LocationInfo[]> {
      return await this.api.get<x.LocationInfo[]>("Settings/GetChildLocations", {  });
  }
  public async GetPricelistInfo(id: number, childId: number, ) : Promise<x.T4PricelistInfo> {
      return await this.api.get<x.T4PricelistInfo>("Settings/GetPricelistInfo", { id: id, childId: childId });
  }
  public async SavePricelist(childId: number, data: x.T4PricelistInfo) : Promise<any> {
      return await this.api.post<any>("Settings/SavePricelist", data, { childId: childId });
  }
  public async CreatePricelist(type: any, childId: number, ) : Promise<any> {
      return await this.api.put<any>("Settings/CreatePricelist", null, { type: type, childId: childId });
  }
  public async DeletePricelist(id: number, childId: number, ) : Promise<any> {
      return await this.api.delete<any>("Settings/DeletePricelist", { id: id, childId: childId });
  }
  public async GetCountries() : Promise<x.Country[]> {
      return await this.api.get<x.Country[]>("Settings/GetCountries", {  });
  }
  public async GetCities(country: string, ) : Promise<x.Country[]> {
      return await this.api.get<x.Country[]>("Settings/GetCities", { country: country });
  }
  public async GetEmailTemplates() : Promise<any> {
      return await this.api.get<any>("Settings/GetEmailTemplates", {  });
  }
  public async GetContentTemplatesByKey(type: any, key: string, ) : Promise<x.EmailTemplateInfo[]> {
      return await this.api.get<x.EmailTemplateInfo[]>("Settings/GetContentTemplatesByKey", { type: type, key: key });
  }
  public async GetEmailTemplatesByContextId() : Promise<x.EmailTemplateInfo[]> {
      return await this.api.get<x.EmailTemplateInfo[]>("Settings/GetEmailTemplatesByContextId", {  });
  }
  public async SaveEmailTemplate(emailTemplateInfo: x.EmailTemplateInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Settings/SaveEmailTemplate", null, { emailTemplateInfo: emailTemplateInfo });
  }
  public async DeleteEmailTemplate(key: string, friendlyName: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Settings/DeleteEmailTemplate", { key: key, friendlyName: friendlyName });
  }
  public async SaveObjectTypeClass(objectTypeClassInfo: x.ObjectTypeClassInfo) : Promise<x.ObjectTypeClassInfo> {
      return await this.api.post<x.ObjectTypeClassInfo>("Settings/SaveObjectTypeClass", objectTypeClassInfo, {  });
  }
  public async GetObjectTypeClassesByPhotoAngleId(photoAngleId: number, ) : Promise<x.ObjectTypeClassInfo[]> {
      return await this.api.get<x.ObjectTypeClassInfo[]>("Settings/GetObjectTypeClassesByPhotoAngleId", { photoAngleId: photoAngleId });
  }
  public async GetAllObjectTypeClasses() : Promise<any> {
      return await this.api.get<any>("Settings/GetAllObjectTypeClasses", {  });
  }
  public async GetObjectTypeClassesWithMinDistance() : Promise<x.ObjectTypeClassInfo[]> {
      return await this.api.get<x.ObjectTypeClassInfo[]>("Settings/GetObjectTypeClassesWithMinDistance", {  });
  }
  public async GetDefaultObjectTypeClasses() : Promise<x.ObjectTypeClassInfo[]> {
      return await this.api.get<x.ObjectTypeClassInfo[]>("Settings/GetDefaultObjectTypeClasses", {  });
  }
  public async GetObjectTypeClassesById(Id: number, ) : Promise<x.ObjectTypeClassInfo> {
      return await this.api.get<x.ObjectTypeClassInfo>("Settings/GetObjectTypeClassesById", { Id: Id });
  }
  public async DeleteObjectTypeClass(classId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Settings/DeleteObjectTypeClass", { classId: classId });
  }
  public async SaveObjectTypeClassAttrribute(objectTypeClassAttributesInfo: x.ObjectTypeClassAttributesInfo) : Promise<number> {
      return await this.api.post<number>("Settings/SaveObjectTypeClassAttrribute", objectTypeClassAttributesInfo, {  });
  }
  public async GetObjectTypeClassAttributesByClassId(classId: number, ) : Promise<x.ObjectTypeClassAttributesInfo[]> {
      return await this.api.get<x.ObjectTypeClassAttributesInfo[]>("Settings/GetObjectTypeClassAttributesByClassId", { classId: classId });
  }
  public async DeleteObjectTypeClassAttributes(attrId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Settings/DeleteObjectTypeClassAttributes", { attrId: attrId });
  }
  public async SaveTypeAttributes(typeAttributeInfo: x.TypeAttributeInfo[], ) : Promise<any> {
      return await this.api.post<any>("Settings/SaveTypeAttributes", null, { typeAttributeInfo: typeAttributeInfo });
  }
  public async DeleteTypeAttributes(attrId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Settings/DeleteTypeAttributes", { attrId: attrId });
  }
  public async GetSafetyCheckQuestions() : Promise<x.SafetyCheckQuestionInfo[]> {
      return await this.api.get<x.SafetyCheckQuestionInfo[]>("Settings/GetSafetyCheckQuestions", {  });
  }
  public async SaveSafetyCheckQuestions(safetyCheckQuestionInfo: x.SafetyCheckQuestionInfo, ) : Promise<boolean> {
      return await this.api.post<boolean>("Settings/SaveSafetyCheckQuestions", null, { safetyCheckQuestionInfo: safetyCheckQuestionInfo });
  }
  public async DeleteSafetyCheckQuestion(safetyCQId: number, ) : Promise<boolean> {
      return await this.api.delete<boolean>("Settings/DeleteSafetyCheckQuestion", { safetyCQId: safetyCQId });
  }
  public async GetObjectTypeClassesBySafetyQueId(QuesId: number, ) : Promise<x.ObjectTypeClassInfo[]> {
      return await this.api.get<x.ObjectTypeClassInfo[]>("Settings/GetObjectTypeClassesBySafetyQueId", { QuesId: QuesId });
  }
  public async GetSetting(key: string, ) : Promise<x.GeneralSetting> {
      return await this.api.get<x.GeneralSetting>("Settings/GetSetting", { key: key });
  }
  public async GetSettingAsString(key: string, ) : Promise<string> {
      return await this.api.get<string>("Settings/GetSettingAsString", { key: key });
  }
  public async SaveSetting(key: string, dataType: string, boolValue: boolean, stringValue: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/SaveSetting", { key: key, dataType: dataType, boolValue: boolValue, stringValue: stringValue });
  }
  public async GetRoles() : Promise<x.Role[]> {
      return await this.api.get<x.Role[]>("Settings/GetRoles", {  });
  }
  public async GetRolesForUser(userName: string, ) : Promise<x.Role[]> {
      return await this.api.get<x.Role[]>("Settings/GetRolesForUser", { userName: userName });
  }
  public async AddRoleToUser(userName: string, roleId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/AddRoleToUser", { userName: userName, roleId: roleId });
  }
  public async SetRolesForUser(roles: string[], userName: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("Settings/SetRolesForUser", null, { roles: roles, userName: userName });
  }
  public async RemoveRoleFromUser(userName: string, roleId: string, ) : Promise<boolean> {
      return await this.api.get<boolean>("Settings/RemoveRoleFromUser", { userName: userName, roleId: roleId });
  }
  public async FilterUsers(searchText: string, limit: number, ) : Promise<x.User[]> {
      return await this.api.get<x.User[]>("Settings/FilterUsers", { searchText: searchText, limit: limit });
  }
  public async GetPrivateKey() : Promise<string> {
      return await this.api.get<string>("Settings/GetPrivateKey", {  });
  }
  public async GetIframeUrl() : Promise<string> {
      return await this.api.get<string>("Settings/GetIframeUrl", {  });
  }
}
@Injectable({providedIn: 'root' })
export class T4CCService {
  constructor(private api: ApiService) {}
  public async GetRentalInfo(rentalId: any, ) : Promise<x.RentalInfo> {
      return await this.api.get<x.RentalInfo>("CC/GetRentalInfo", { rentalId: rentalId });
  }
  public async GetInvoices(from: moment.Moment, to: moment.Moment, ) : Promise<x.T4InvoiceInfo[]> {
      return await this.api.get<x.T4InvoiceInfo[]>("CC/GetInvoices", { from: from.toISOString(), to: to.toISOString() });
  }
  public async GetInvoicesForCustomer(customerId: string, from: moment.Moment, to: moment.Moment, ) : Promise<x.T4InvoiceInfo[]> {
      return await this.api.get<x.T4InvoiceInfo[]>("CC/GetInvoicesForCustomer", { customerId: customerId, from: from.toISOString(), to: to.toISOString() });
  }
  public async GetInvoiceDetails(invoiceId: string, ) : Promise<x.T4InvoiceInfo> {
      return await this.api.get<x.T4InvoiceInfo>("CC/GetInvoiceDetails", { invoiceId: invoiceId });
  }
  public async GetPendingInvoices() : Promise<x.T4InvoiceInfo[]> {
      return await this.api.get<x.T4InvoiceInfo[]>("CC/GetPendingInvoices", {  });
  }
  public async DeleteInvoiceLines(invoiceId: string, productId: string, productName: string, comment: string, ) : Promise<boolean> {
      return await this.api.delete<boolean>("CC/DeleteInvoiceLines", { invoiceId: invoiceId, productId: productId, productName: productName, comment: comment });
  }
  public async CreditInvoiceLines(invoiceId: string, comment: string, invoiceLines: x.T4InvoiceLine[]) : Promise<boolean> {
      return await this.api.post<boolean>("CC/CreditInvoiceLines", invoiceLines, { invoiceId: invoiceId, comment: comment });
  }
  public async Resend(invoiceId: string, ) : Promise<boolean> {
      return await this.api.post<boolean>("CC/Resend", null, { invoiceId: invoiceId });
  }
  public async GetProducts() : Promise<x.ProductInfo[]> {
      return await this.api.get<x.ProductInfo[]>("CC/GetProducts", {  });
  }
  public async GetProductPrices(contextId: string, ) : Promise<x.ProductPriceInfo[]> {
      return await this.api.get<x.ProductPriceInfo[]>("CC/GetProductPrices", { contextId: contextId });
  }
  public async UpdateProductPrice(contextId: string, productPrice: x.ProductPriceInfo[]) : Promise<x.ProductPriceInfo[]> {
      return await this.api.post<x.ProductPriceInfo[]>("CC/UpdateProductPrice", productPrice, { contextId: contextId });
  }
  public async RemoveProductPrice(contextId: string, id: string, ) : Promise<x.ProductPriceInfo[]> {
      return await this.api.post<x.ProductPriceInfo[]>("CC/RemoveProductPrice", null, { contextId: contextId, id: id });
  }
  public async GetActualProductPrices(contextId: string, ) : Promise<x.ProductPriceInfo[]> {
      return await this.api.post<x.ProductPriceInfo[]>("CC/GetActualProductPrices", null, { contextId: contextId });
  }
}
@Injectable({providedIn: 'root' })
export class T4ServiceGuyUseCases {
  constructor(private api: ApiService) {}
}
@Injectable({providedIn: 'root' })
export class T4ChangeRentalService {
  constructor(private api: ApiService) {}
  public async ChangePickupTime(rentalId: any, newPickupTime: moment.Moment, keepLength: boolean, ) : Promise<x.BookingValidation> {
      return await this.api.put<x.BookingValidation>("ChangeRental/ChangePickupTime", null, { rentalId: rentalId, newPickupTime: newPickupTime.toISOString(), keepLength: keepLength });
  }
  public async ChangeTrailer(rentalId: any, objectId: any, ) : Promise<x.BookingValidation> {
      return await this.api.put<x.BookingValidation>("ChangeRental/ChangeTrailer", null, { rentalId: rentalId, objectId: objectId });
  }
}
@Injectable({providedIn: 'root' })
export class T4PaymentService {
  constructor(private api: ApiService) {}
}
